// import axios from "axios";
// import React, { useEffect, useState, useContext } from "react";
// import { useNavigate, useParams, useLocation  } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { RatesContext } from "../Pages/RatesContext";
// import { useToast } from "../Toast/ToastContext";

// function UpdateSales({ toggleSidebar }) {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation(); // NEW
//   const toast = useToast();
//   const [navSource, setNavSource] = useState(null); // NEW
//   const { rates } = useContext(RatesContext) || {
//     rates: { gold_1g_rate: "", silver_10g_rate: "", cold_coin_rate: "" },
//   };

//   // State declarations
//   const [showModal, setShowModal] = useState(false);
//   const [infoModal, setInfoModal] = useState(false);
//   const [selectedAction, setSelectedAction] = useState("New");
//   const [paymentType, setPaymentType] = useState("");
//   const [paymentAmount, setPaymentAmount] = useState("");
//   const [payments, setPayments] = useState([]);
//   const [customerDetails, setCustomerDetails] = useState({
//     name: "",
//     mobile: "",
//   });
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [customerGetting, setCustomerGetting] = useState([]);
//   const [filteredCustomers, setFilteredCustomers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [items, setItems] = useState([]);
//   const [editingIndex, setEditingIndex] = useState(null);
//   const [dailyRatesGetting, setDailyRatesGetting] = useState([]);
//   const [makingWastagePercentage, setMakingWastagePercentage] = useState("");
//   const [makingWastageValue, setMakingWastageValue] = useState("");
//   const [isRoundOffEnabled, setIsRoundOffEnabled] = useState(false);
//   const [isRateManuallyEdited, setIsRateManuallyEdited] = useState(false);
//   const [userdata, setUserdata] = useState([]);
//   const [selectedManager, setSelectedManager] = useState("");
//   const [selectedStaff, setSelectedStaff] = useState("");
//   const [staffList, setStaffList] = useState([]);

//   // Stone value / Adjustment (matches AddSales item structure)
//   const [stoneValue, setStoneValue] = useState("");
//   const [adjustment, setAdjustment] = useState("");
//   const [isAdjustmentApplied, setIsAdjustmentApplied] = useState(false);

//   // Stock Data State (matches AddSales)
//   const [stockData, setStockData] = useState([]);
//   const [stockLoading, setStockLoading] = useState(false);

//   const [updateData, setUpdateData] = useState({
//     sales_no: "",
//     sales_date: getCurrentDate(),
//     customer_type: "",
//     customer_id: "",
//     sub_total: "0.00",
//     total: "0.00",
//     exchange_old_value: "0.00",
//     discount: "",
//     discount_value: "0.00",
//     tax: "",
//     tax_percentage: "0.00",
//     paid: "0.00",
//     balance: "0.00",
//     notes: "",
//     round_off: "0.00",
//     net_total: "0.00",
//     select_category: "",
//     select_type: "",
//     quantity: "",
//     weight: "",
//     rate: "",
//     making_charges: "",
//     amount: "0.00",
//     manager: "", // Store manager user_id
//     staff: "", // Store staff name
//     item_list: [],
//     payment_history: [],
//   });

//   // Get current date in YYYY-MM-DD format
//   function getCurrentDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   }

//   // Format date to DD-MM-YYYY
//   function formatDateToDDMMYYYY(dateString) {
//     const [year, month, day] = dateString.split("-");
//     return `${day}-${month}-${year}`;
//   }

//   // ==================== STOCK FUNCTIONS ====================

//   // Fetch stock data
//   const fetchStockData = async () => {
//     try {
//       setStockLoading(true);
//       const response = await axios.get(`${ApiUrl}/Api/stock.php`);
//       const data = Array.isArray(response.data?.data) ? response.data.data : [];
//       setStockData(data);
//     } catch (error) {
//       console.error("Error fetching stock data:", error.message);
//       toast.error("Failed to fetch stock data", 3000, "topRight");
//       setStockData([]);
//     } finally {
//       setStockLoading(false);
//     }
//   };

//   // Check stock availability for a specific item
//   const checkStockAvailability = (category, itemName, quantity, selectedTypeId) => {
//     let stockItem = null;

//     if (selectedTypeId) {
//       const selectedProduct = products.find(
//         (p) => String(p.id) === String(selectedTypeId)
//       );

//       if (selectedProduct) {
//         const productName = selectedProduct.item_name_english || selectedProduct.item_name;
//         stockItem = stockData.find(
//           (item) =>
//             item.category?.toLowerCase() === category?.toLowerCase() &&
//             (item.item?.toLowerCase() === productName?.toLowerCase() ||
//               item.item_name_english?.toLowerCase() === productName?.toLowerCase())
//         );

//         if (!stockItem) {
//           stockItem = stockData.find(
//             (item) =>
//               item.category?.toLowerCase() === category?.toLowerCase() &&
//               (item.item?.toLowerCase().includes(productName?.toLowerCase()) ||
//                 item.item_name_english?.toLowerCase().includes(productName?.toLowerCase()))
//           );
//         }
//       }
//     }

//     if (!stockItem && itemName) {
//       stockItem = stockData.find(
//         (item) =>
//           item.category?.toLowerCase() === category?.toLowerCase() &&
//           (item.item?.toLowerCase() === itemName?.toLowerCase() ||
//             item.item_name_english?.toLowerCase() === itemName?.toLowerCase())
//       );
//     }

//     if (!stockItem && selectedAction === "Exchange") {
//       stockItem = stockData.find(
//         (item) => item.category?.toLowerCase() === category?.toLowerCase()
//       );
//     }

//     if (!stockItem) {
//       console.warn("Item not found in stock:", { category, itemName, selectedTypeId });

//       // A product must exist in the general stock before it can be sold,
//       // regardless of action type (New, Po-Sale, etc.).
//       return {
//         available: false,
//         message: "This product is not present in general stock. Please add it to stock before selling.",
//         availableQuantity: 0,
//         itemFound: false,
//       };
//     }

//     const availableQuantity = parseFloat(stockItem.avaliable_quantity) || 0;
//     const requestedQuantity = parseFloat(quantity) || 0;

//     if (requestedQuantity > availableQuantity) {
//       return {
//         available: false,
//         message: `Only ${availableQuantity} units available. Requested: ${requestedQuantity}`,
//         availableQuantity: availableQuantity,
//         itemFound: true,
//         stockItem: stockItem,
//       };
//     }

//     return {
//       available: true,
//       message: "Stock available",
//       availableQuantity: availableQuantity,
//       itemFound: true,
//       stockItem: stockItem,
//     };
//   };

//   // Get stock status for display
//   const getStockStatus = (category, itemName, selectedTypeId) => {
//     let stockItem = null;

//     if (selectedTypeId) {
//       const selectedProduct = products.find(
//         (p) => String(p.id) === String(selectedTypeId)
//       );

//       if (selectedProduct) {
//         const productName = selectedProduct.item_name_english || selectedProduct.item_name;
//         stockItem = stockData.find(
//           (item) =>
//             item.category?.toLowerCase() === category?.toLowerCase() &&
//             (item.item?.toLowerCase() === productName?.toLowerCase() ||
//               item.item_name_english?.toLowerCase() === productName?.toLowerCase())
//         );

//         if (!stockItem) {
//           stockItem = stockData.find(
//             (item) =>
//               item.category?.toLowerCase() === category?.toLowerCase() &&
//               (item.item?.toLowerCase().includes(productName?.toLowerCase()) ||
//                 item.item_name_english?.toLowerCase().includes(productName?.toLowerCase()))
//           );
//         }
//       }
//     }

//     if (!stockItem && itemName) {
//       stockItem = stockData.find(
//         (item) =>
//           item.category?.toLowerCase() === category?.toLowerCase() &&
//           (item.item?.toLowerCase() === itemName?.toLowerCase() ||
//             item.item_name_english?.toLowerCase() === itemName?.toLowerCase())
//       );
//     }

//     if (!stockItem) {
//       return { status: "unknown", available: 0, itemFound: false };
//     }

//     const available = parseFloat(stockItem.avaliable_quantity) || 0;
//     let status = "available";
//     if (available === 0) status = "out-of-stock";
//     else if (available < 5) status = "low-stock";

//     return { status, available, itemFound: true };
//   };

//     useEffect(() => {
//     if (location.state?.source === "blue-page") {
//       setNavSource({
//         selectedRowId: location.state.selectedRowId,
//         returnTab: location.state.returnTab,
//       });
//     }
//   }, [location.state]);

//   const goBackToOrigin = () => {
//     if (navSource) {
//       navigate("/balance/blue-page-balance", { // ⬅ swap in your actual route path for BluePageBalance
//         state: {
//           from: "balance-page",
//           selectedRowId: navSource.selectedRowId,
//           returnTab: navSource.returnTab,
//         },
//       });
//     } else {
//       navigate("/sales");
//     }
//   };

//   // ==================== END STOCK FUNCTIONS ====================

//   // Fetch initial data
//   useEffect(() => {
//     toggleSidebar();
//     fetchProducts();
//     fetchCustomer();
//     fetchDailyRatesData();
//     fetchuserdata();
//     fetchStockData(); // Fetch stock data on component mount
//   }, [id]);

//   // Refresh stock data periodically (matches AddSales)
//   useEffect(() => {
//     const interval = setInterval(() => {
//       fetchStockData();
//     }, 30000); // Refresh every 30 seconds
//     return () => clearInterval(interval);
//   }, []);

//   useEffect(() => {
//     if (id && userdata.length > 0) {
//       fetchSalesData();
//     }
//   }, [id, userdata]);

//   const fetchuserdata = async () => {
//     try {
//       const fetchuser = await axios.get(`${ApiUrl}/Api/user.php`);
//       const userDataArray = Array.isArray(fetchuser.data.data)
//         ? fetchuser.data.data
//         : [];
//       setUserdata(userDataArray);
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//       setUserdata([]);
//       toast.error("Failed to fetch user data", 3000, "topRight");
//     }
//   };

//   const handleManagerChange = (e) => {
//     const managerId = e.target.value;
//     setSelectedManager(managerId);

//     if (managerId) {
//       const selectedManagerObj = userdata.find(
//         (user) => user.id === parseInt(managerId),
//       );
//       const managerUserId = selectedManagerObj
//         ? selectedManagerObj.user_id
//         : "";
//       const allStaff = userdata.filter(
//         (user) => user.role === "Employee" || user.role === "employee",
//       );
//       setStaffList(allStaff);
//       setUpdateData((prev) => ({
//         ...prev,
//         manager: managerUserId, // Store manager user_id (e.g., "MG-001")
//       }));
//     } else {
//       setUpdateData((prev) => ({
//         ...prev,
//         manager: "",
//       }));
//     }
//   };

//   const handleStaffChange = (e) => {
//     const staffName = e.target.value;
//     setSelectedStaff(staffName);
//     setUpdateData((prev) => ({
//       ...prev,
//       staff: staffName, // Store staff name
//     }));
//   };

//   const fetchDailyRatesData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/daily_rates.php`);
//       setDailyRatesGetting(response.data.data || []);
//     } catch (error) {
//       console.error("Error fetching daily rates:", error.message);
//     }
//   };

//   const fetchProducts = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/product.php`);
//       setProducts(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching products:", error.message);
//       setProducts([]);
//     }
//   };

//   const fetchCustomer = async (customerType = "") => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/customer.php`);
//       const data = response.data?.data || [];
//       const filtered = customerType
//         ? data.filter((customer) => customer.customer_type === customerType)
//         : data;
//       setCustomerGetting(filtered);
//     } catch (error) {
//       console.error("Error fetching customers:", error.message);
//       setCustomerGetting([]);
//     }
//   };

//   const fetchSalesData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/sales.php/${id}`);
//       if (response.data && response.data.data) {
//         const salesData = response.data.data[0];

//         if (salesData.customer_id) {
//           const customerResponse = await axios.get(
//             `${ApiUrl}/Api/customer.php/${salesData.customer_id}`,
//           );
//           if (customerResponse.data && customerResponse.data.data) {
//             const customer = customerResponse.data.data[0];
//             setCustomerDetails({
//               name: customer.name,
//               mobile: customer.mobile,
//             });
//             setSearchTerm(`${customer.customer_id} - ${customer.name}`);
//           }
//         }

//         // Find manager and set selectedManager
//         const managerObj = userdata.find(
//           (u) => u.user_id === salesData.manager,
//         );
//         const managerId = managerObj ? managerObj.id : "";
//         setSelectedManager(managerId);

//         // Set staff list based on manager
//         if (managerId) {
//           const selectedManagerObj = userdata.find(
//             (u) => u.id === parseInt(managerId),
//           );
//           const managerUserId = selectedManagerObj
//             ? selectedManagerObj.user_id
//             : "";
//           setStaffList(
//             Array.isArray(userdata)
//               ? userdata.filter(
//                   (user) => user.role === "Employee" || user.role === "employee",
//                 )
//               : [],
//           );
//         }

//         setSelectedStaff(salesData.staff || "");

//         setUpdateData({
//           sales_no: salesData.sales_no || "",
//           sales_date: salesData.sales_date || getCurrentDate(),
//           customer_type: salesData.customer_type || "",
//           customer_id: salesData.customer_id || "",
//           sub_total: salesData.sub_total || "0.00",
//           total: salesData.total || "0.00",
//           tax: salesData.tax || "",
//           tax_percentage: salesData.tax_percentage || "0.00",
//           net_total: salesData.net_total || "0.00",
//           discount: salesData.discount || "",
//           discount_value: salesData.discount_value || "0.00",
//           paid: salesData.paid || "0.00",
//           balance: salesData.balance || "0.00",
//           notes: salesData.notes || "",
//           round_off: salesData.round_off || "0.00",
//           exchange_old_value: salesData.exchange_old_value || "0.00",
//           select_category: "",
//           select_type: "",
//           quantity: "",
//           weight: "",
//           rate: "",
//           making_charges: "",
//           amount: "0.00",
//           manager: salesData.manager || "",
//           staff: salesData.staff || "",
//           item_list: salesData.item_list || [],
//           payment_history: salesData.payment_history || [],
//         });

//         if (salesData.item_list && Array.isArray(salesData.item_list)) {
//           setItems(
//             salesData.item_list.map((item) => ({
//               sales_no: item.sales_no || salesData.sales_no,
//               category: item.category || "",
//               item: item.item || "",
//               type_id: item.type_id || "",
//               type_name:
//                 item.type_name ||
//                 item.item ||
//                 (item.action_type === "Exchange" ? `Old ${item.category}` : ""),
//               type_name_tamil: item.type_name_tamil || "",
//               quantity: item.quantity || "",
//               weight: item.weight || "",
//               making_charges: item.making_charges || "",
//               making_wastage: item.making_wastage || "",
//               making_wastage_percentage: item.making_wastage_percentage || "",
//               rate: item.rate || "",
//               amount: item.amount || "0.00",
//               action_type: item.action_type || "New",
//               manager: item.manager || salesData.manager || "",
//               staff: item.staff || salesData.staff || "",
//               stone_value: item.stone_value || "0.00",
//               adjustment: item.adjustment || "0.00",
//             })),
//           );

//           const uniqueActions = [
//             ...new Set(salesData.item_list.map((item) => item.action_type)),
//           ];
//           if (uniqueActions.length === 1) {
//             setSelectedAction(uniqueActions[0] || "New");
//           }
//         }

//         if (
//           salesData.payment_history &&
//           Array.isArray(salesData.payment_history)
//         ) {
//           setPayments(salesData.payment_history);
//         }

//         setIsRoundOffEnabled(salesData.round_off !== "0.00");
//       }
//     } catch (error) {
//       console.error("Error fetching sales data:", error);
//       toast.error("Failed to load sales data", 3000, "topRight");
//     }
//   };

//   // Filter customers based on search term
//   useEffect(() => {
//     const filtered = customerGetting.filter(
//       (customer) =>
//         customer.customer_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         customer.name.toLowerCase().includes(searchTerm.toLowerCase()),
//     );
//     setFilteredCustomers(filtered);
//   }, [searchTerm, customerGetting]);

//   const handleSelectCustomer = (customer) => {
//     setUpdateData((prev) => ({
//       ...prev,
//       customer_id: customer.customer_id,
//       customer_type: customer.customer_type,
//     }));
//     setCustomerDetails({
//       name: customer.name,
//       mobile: customer.mobile,
//     });
//     setSearchTerm(`${customer.customer_id} - ${customer.name}`);
//     setShowDropdown(false);
//   };

//   // ===================================================================
//   // Calculate item amount — matches AddSales: purity-adjusted, includes
//   // stone value for New/Po-Sale, and is gated by isAdjustmentApplied so
//   // a manual Exchange adjustment isn't silently overwritten. Editing an
//   // item resets isAdjustmentApplied to false (see handleEditItem) so the
//   // amount keeps recalculating live while you edit, instead of freezing.
//   // ===================================================================
//   useEffect(() => {
//     if (!updateData.quantity || !updateData.weight || !updateData.rate) {
//       setUpdateData((prev) => ({ ...prev, amount: "0.00" }));
//       return;
//     }
//     if (isAdjustmentApplied) return;

//     // NOTE: updateData.rate already has the selected product's Pure %
//     // baked in (see the Rate auto-fill effect below), so amount is
//     // now just quantity x weight x rate — no separate purity multiply.
//     let baseAmount =
//       parseFloat(updateData.quantity) *
//       parseFloat(updateData.weight) *
//       parseFloat(updateData.rate);

//     if (selectedAction === "New" && updateData.making_charges) {
//       baseAmount += parseFloat(updateData.making_charges);
//     }
//     if (makingWastageValue) {
//       const wastage = parseFloat(makingWastageValue);
//       if (selectedAction === "Exchange") {
//         baseAmount -= wastage;
//       } else {
//         baseAmount += wastage;
//       }
//     }
//     if (
//       (selectedAction === "New" || selectedAction === "Po-Sale") &&
//       stoneValue
//     ) {
//       baseAmount += parseFloat(stoneValue);
//     }

//     setUpdateData((prev) => ({ ...prev, amount: baseAmount.toFixed(2) }));
//   }, [
//     updateData.quantity,
//     updateData.weight,
//     updateData.rate,
//     updateData.making_charges,
//     makingWastageValue,
//     selectedAction,
//     isAdjustmentApplied,
//     stoneValue,
//     updateData.select_type,
//     products,
//   ]);

//   const applyAdjustment = (sign) => {
//     const value = parseFloat(adjustment) || 0;
//     if (value === 0) return;
//     const adjustmentValue = sign === "+" ? value : -value;
//     if (selectedAction === "Exchange") {
//       const currentWeight = parseFloat(updateData.weight) || 0;
//       const newWeight = currentWeight + adjustmentValue;
//       if (newWeight <= 0) {
//         toast.error("Weight cannot be zero or negative", 2000, "topRight");
//         return;
//       }
//       const rate = parseFloat(updateData.rate) || 0;
//       const newAmount = (newWeight * rate).toFixed(2);
//       setUpdateData((prev) => ({
//         ...prev,
//         weight: newWeight.toFixed(3),
//         amount: newAmount,
//       }));
//       setAdjustment(adjustmentValue.toFixed(2));
//     } else {
//       const currentAmount = parseFloat(updateData.amount) || 0;
//       const newAmount = currentAmount + adjustmentValue;
//       setUpdateData((prev) => ({ ...prev, amount: newAmount.toFixed(2) }));
//       setIsAdjustmentApplied(true);
//       setAdjustment(adjustmentValue.toFixed(2));
//     }
//   };

//   const renderAdjustmentInput = () => (
//     <div className="col-md-2">
//       <label className="form-label">Adjustment ₹</label>
//       <div className="input-group">
//         <button
//           type="button"
//           className="btn btn-outline-danger btn-sm"
//           style={{ height: "34px" }}
//           onClick={() => applyAdjustment("-")}
//         >
//           –
//         </button>
//         <input
//           type="text"
//           className="form-control"
//           placeholder="0"
//           value={adjustment}
//           onChange={(e) => {
//             if (/^\d*\.?\d*$/.test(e.target.value))
//               setAdjustment(e.target.value);
//           }}
//         />
//         <button
//           type="button"
//           className="btn btn-outline-success btn-sm"
//           style={{ height: "34px" }}
//           onClick={() => applyAdjustment("+")}
//         >
//           +
//         </button>
//       </div>
//     </div>
//   );

//   // Calculate totals
//   useEffect(() => {
//     const subtotal = items
//       .filter((item) => item.action_type !== "Exchange")
//       .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
//     setUpdateData((prev) => ({
//       ...prev,
//       total: subtotal.toFixed(2),
//       sub_total: subtotal.toFixed(2),
//     }));
//   }, [items]);

//   // Calculate discount, tax, round-off, net total, exchange_old_value, and balance
//   useEffect(() => {
//     const total = parseFloat(updateData.total) || 0;
//     const discountPercentage = parseFloat(updateData.discount) || 0;
//     const taxPercentage = parseFloat(updateData.tax) || 0;
//     const exchangeOldValue = items
//       .filter((item) => item.action_type === "Exchange")
//       .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

//     const discountAmount = (total * discountPercentage) / 100;
//     const subtotal = total - discountAmount;
//     const taxAmount = (subtotal * taxPercentage) / 100;
//     let netTotal = subtotal + taxAmount;

//     let roundOffValue = 0;
//     if (isRoundOffEnabled) {
//       const decimalPart = netTotal - Math.floor(netTotal);
//       if (decimalPart < 0.5) {
//         roundOffValue = -decimalPart;
//         netTotal = Math.floor(netTotal);
//       } else {
//         roundOffValue = 1 - decimalPart;
//         netTotal = Math.ceil(netTotal);
//       }
//     }

//     let balance =
//       netTotal - exchangeOldValue - parseFloat(updateData.paid || 0);
//     if (total === 0) {
//       balance = parseFloat(updateData.paid || 0) - exchangeOldValue;
//     }

//     setUpdateData((prev) => ({
//       ...prev,
//       discount_value: discountAmount.toFixed(2),
//       sub_total: subtotal.toFixed(2),
//       tax_percentage: taxAmount.toFixed(2),
//       exchange_old_value: exchangeOldValue.toFixed(2),
//       net_total: netTotal.toFixed(2),
//       round_off: roundOffValue.toFixed(2),
//       balance: balance.toFixed(2),
//     }));
//   }, [
//     updateData.total,
//     updateData.discount,
//     updateData.tax,
//     isRoundOffEnabled,
//     updateData.paid,
//     items,
//   ]);

//   const handleCategoryChange = (e) => {
//     const selectedCategory = e.target.value;
//     let rate = "";
//     setIsRateManuallyEdited(false);

//     const today = formatDateToDDMMYYYY(getCurrentDate());
//     const todayRate =
//       dailyRatesGetting.find((rate) => rate.date === today) || {};

//     if (selectedCategory === "Gold") {
//       if (selectedAction === "Old Sales") {
//         rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
//       } else if (selectedAction === "Exchange") {
//         rate = "";
//       } else {
//         rate = todayRate.gold_1g_rate || rates.gold_1g_rate || "";
//       }
//     } else if (selectedCategory === "Silver") {
//       if (selectedAction === "Exchange") {
//         rate = "";
//       } else {
//         rate = (
//           parseFloat(todayRate.silver_10g_rate) ||
//           parseFloat(rates.silver_10g_rate) ||
//           ""
//         ).toString();
//       }
//     } else if (selectedCategory === "Gold Coin") {
//       if (selectedAction === "Exchange") {
//         rate = "";
//       } else {
//         rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
//       }
//     } else if (selectedCategory === "Silver Coin") {
//       if (selectedAction === "Exchange") {
//         rate = "";
//       } else {
//         rate = todayRate.silver_coin_rate || rates.silver_coin_rate || "";
//       }
//     }

//     setUpdateData((prev) => ({
//       ...prev,
//       select_category: selectedCategory,
//       select_type: "",
//       rate,
//     }));
//   };

//   // Reset rate when action changes
//   useEffect(() => {
//     if (isRateManuallyEdited && selectedAction === "Exchange") {
//       return;
//     }

//     let rate = "";
//     const today = formatDateToDDMMYYYY(getCurrentDate());
//     const todayRate =
//       dailyRatesGetting.find((rate) => rate.date === today) || {};

//     if (updateData.select_category === "Gold") {
//       if (selectedAction === "Old Sales") {
//         rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
//       } else if (selectedAction === "Exchange") {
//         rate = "";
//       } else {
//         rate = todayRate.gold_1g_rate || rates.gold_1g_rate || "";
//       }
//     } else if (updateData.select_category === "Silver") {
//       if (selectedAction === "Exchange") {
//         rate = "";
//       } else {
//         rate = todayRate.silver_10g_rate
//           ? todayRate.silver_10g_rate
//           : rates.silver_10g_rate
//             ? rates.silver_10g_rate
//             : "";
//       }
//     } else if (updateData.select_category === "Gold Coin") {
//       if (selectedAction === "Exchange") {
//         rate = "";
//       } else {
//         rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
//       }
//     } else if (updateData.select_category === "Silver Coin") {
//       if (selectedAction === "Exchange") {
//         rate = "";
//       } else {
//         rate = todayRate.silver_coin_rate || rates.silver_coin_rate || "";
//       }
//     }

//     // Apply the selected product's purity (Pure %) to today's market
//     // rate, so the Rate field shown/stored on the item is the actual
//     // sale rate for that specific product, not just the raw market rate.
//     if (rate && updateData.select_type && selectedAction !== "Exchange") {
//       const selectedProductForRate = products.find(
//         (p) => String(p.id) === String(updateData.select_type)
//       );
//       if (selectedProductForRate?.pure_percent) {
//         const purity = parseFloat(selectedProductForRate.pure_percent) / 100;
//         rate = (parseFloat(rate) * purity).toFixed(2);
//       }
//     }

//     setUpdateData((prev) => ({
//       ...prev,
//       rate,
//     }));
//   }, [
//     selectedAction,
//     updateData.select_category,
//     updateData.select_type,
//     dailyRatesGetting,
//     rates,
//     isRateManuallyEdited,
//     products,
//   ]);

//   // Filter products based on selected category
//   useEffect(() => {
//     if (updateData.select_category) {
//       const filtered = products.filter(
//         (product) => product.category === updateData.select_category,
//       );
//       setFilteredProducts(filtered);
//     } else {
//       setFilteredProducts([]);
//     }
//   }, [updateData.select_category, products]);

//   const handleMakingWastagePercentageChange = (e) => {
//     const percentage = e.target.value;
//     if (/^\d*\.?\d{0,2}$/.test(percentage)) {
//       setMakingWastagePercentage(percentage);
//       setMakingWastageValue("");
//       if (
//         updateData.quantity &&
//         updateData.weight &&
//         updateData.rate &&
//         percentage
//       ) {
//         const baseAmount =
//           parseFloat(updateData.quantity) *
//           parseFloat(updateData.weight) *
//           parseFloat(updateData.rate);
//         const wastageValue = (baseAmount * parseFloat(percentage)) / 100;
//         setMakingWastageValue(wastageValue.toFixed(2));
//       }
//     }
//   };

//   const handleMakingWastageValueChange = (e) => {
//     const value = e.target.value;
//     if (/^\d*\.?\d*$/.test(value)) {
//       setMakingWastageValue(value);
//       setMakingWastagePercentage("");
//       if (
//         updateData.quantity &&
//         updateData.weight &&
//         updateData.rate &&
//         value
//       ) {
//         const baseAmount =
//           parseFloat(updateData.quantity) *
//           parseFloat(updateData.weight) *
//           parseFloat(updateData.rate);
//         const percentage = (parseFloat(value) / baseAmount) * 100;
//         setMakingWastagePercentage(percentage.toFixed(2));
//       }
//     }
//   };

//   // ==================== handleAddItem (Add / Update item) ====================
//   const handleAddItem = () => {
//     // Step 1: Required fields check
//     if (
//       !updateData.select_category ||
//       (selectedAction !== "Exchange" && !updateData.select_type) ||
//       !updateData.quantity ||
//       !updateData.weight ||
//       !updateData.rate ||
//       !updateData.amount ||
//       !updateData.manager
//     ) {
//       toast.error(
//         "Please fill all required fields, including Manager and Staff",
//         3000,
//         "topRight"
//       );
//       return;
//     }
//     const _roleForStaffCheck =
//       JSON.parse(localStorage.getItem("user") || "{}").role || "";
//     const _isAdminForStaff =
//       _roleForStaffCheck === "Admin" || _roleForStaffCheck === "admin";
//     if (!_isAdminForStaff && !updateData.staff) {
//       toast.error("Please select Staff", 3000, "topRight");
//       return;
//     }

//     // Step 2: STOCK AVAILABILITY CHECK
//     // Skipped for Exchange and Old Sales (stock tracking doesn't apply there)
//     if (selectedAction !== "Exchange" && selectedAction !== "Old Sales") {
//       const selectedProductForStock = products.find(
//         (p) => String(p.id) === String(updateData.select_type)
//       );
//       const itemNameForStock =
//         selectedProductForStock?.item_name_english ||
//         selectedProductForStock?.item_name ||
//         "";
//       const category = updateData.select_category;
//       const quantity = parseFloat(updateData.quantity) || 0;

//       const stockCheck = checkStockAvailability(
//         category,
//         itemNameForStock,
//         quantity,
//         updateData.select_type
//       );

//       if (!stockCheck.available) {
//         toast.error(
//           `❌ Stock Limit Exceeded! ${stockCheck.message}`,
//           5000,
//           "topRight"
//         );
//         return; // ⛔ Stop here - item will NOT be added
//       }

//       if (
//         stockCheck.availableQuantity > 0 &&
//         quantity > stockCheck.availableQuantity * 0.8
//       ) {
//         toast.warning(
//           `⚠️ Low stock warning! Only ${stockCheck.availableQuantity} units available. You're adding ${quantity} units.`,
//           5000,
//           "topRight"
//         );
//       }

//       if (stockCheck.itemFound) {
//         toast.success(
//           `✅ Stock available: ${stockCheck.availableQuantity} units`,
//           2000,
//           "topRight"
//         );
//       }
//     }

//     // Step 3: Purity-based price check
//     // Skipped for Exchange and Old Sales (matches AddSales — those modes
//     // don't price against today's pure rate the same way New/Po-Sale do).
//     if (
//       selectedAction !== "Exchange" &&
//       selectedAction !== "Old Sales" &&
//       updateData.select_type
//     ) {
//       const selectedProductForCheck = products.find(
//         (p) => String(p.id) === String(updateData.select_type)
//       );
//       const purity = selectedProductForCheck?.pure_percent
//         ? parseFloat(selectedProductForCheck.pure_percent) / 100
//         : 1;

//       const qty = parseFloat(updateData.quantity || 0);
//       const weight = parseFloat(updateData.weight || 0);

//       const today = formatDateToDDMMYYYY(getCurrentDate());
//       const todayRateRow = dailyRatesGetting.find((r) => r.date === today) || {};

//       let todaysPureRate = 0;
//       if (updateData.select_category === "Gold" || updateData.select_category === "Gold Coin") {
//         todaysPureRate = parseFloat(
//           todayRateRow.gold_pure_percentage || rates.gold_pure_percentage || 0
//         );
//       } else if (
//         updateData.select_category === "Silver" ||
//         updateData.select_category === "Silver Coin"
//       ) {
//         todaysPureRate = parseFloat(
//           todayRateRow.silver_pure_percentage || rates.silver_pure_percentage || 0
//         );
//       }

//       const finalAmount = parseFloat(updateData.amount || 0); // includes making charge + wastage + stone value
//       const pureRateTotal = qty * weight * purity * todaysPureRate;

//       if (todaysPureRate > 0 && finalAmount < pureRateTotal) {
//         const diff = (pureRateTotal - finalAmount).toFixed(2);
//         toast.error(
//           `⚠️ Amount ₹${finalAmount.toFixed(2)} is below Today's Pure Rate value ₹${pureRateTotal.toFixed(2)} (Diff: ₹${diff})`,
//           4000,
//           "topRight"
//         );
//         return; // ⛔ block — item not added
//       }
//     }

//     // Step 4: Build item object (ONLY REACHED IF ALL CHECKS PASS)
//     const selectedProduct = filteredProducts.find(
//       (p) => p.id === parseInt(updateData.select_type),
//     );
//     const typeName = selectedProduct
//       ? selectedProduct.item_name_english || selectedProduct.item_name
//       : selectedAction === "Exchange"
//         ? `Old ${updateData.select_category}`
//         : "";

//     const newItem = {
//       sales_no: updateData.sales_no,
//       category: updateData.select_category,
//       item: typeName,
//       type_id: updateData.select_type,
//       type_name: typeName,
//       type_name_tamil: selectedProduct?.item_name_tamil || "",
//       quantity: updateData.quantity,
//       weight: updateData.weight,
//       making_charges: updateData.making_charges,
//       making_wastage: makingWastageValue,
//       making_wastage_percentage: makingWastagePercentage,
//       rate: updateData.rate,
//       amount: updateData.amount,
//       action_type: selectedAction,
//       manager: updateData.manager,
//       staff: updateData.staff,
//       stone_value: stoneValue || "0.00",
//       adjustment: adjustment || "0.00",
//     };

//     // Step 5: Add or update item
//     if (editingIndex !== null) {
//       const updatedItems = [...items];
//       updatedItems[editingIndex] = newItem;
//       setItems(updatedItems);
//       setEditingIndex(null);
//     } else {
//       setItems([...items, newItem]);
//     }

//     // Step 6: Reset form fields
//     setUpdateData((prev) => ({
//       ...prev,
//       select_category: "",
//       select_type: "",
//       select_type_name: "",
//       select_type_tamil: "",
//       quantity: "",
//       weight: "",
//       rate: "",
//       making_charges: "",
//       amount: "0.00",
//       manager: "",
//       staff: "",
//     }));
//     setMakingWastagePercentage("");
//     setMakingWastageValue("");
//     setStoneValue("");
//     setAdjustment("");
//     setIsAdjustmentApplied(false);
//     setIsRateManuallyEdited(false);
//     setSelectedManager("");
//     setSelectedStaff("");
//     setStaffList([]);
//   };
//   // ==================== END handleAddItem ====================

//   // ===================================================================
//   // handleEditItem sets isAdjustmentApplied(false) so the amount effect
//   // keeps recalculating live while you edit (matches AddSales' fix —
//   // otherwise the amount would appear frozen after opening an item).
//   // ===================================================================
//   const handleEditItem = (index) => {
//     const item = items[index];

//     // Look up from the full products list, not the (possibly stale) filteredProducts
//     const categoryProducts = products.filter(
//       (p) => p.category === item.category
//     );
//     const selectedProduct =
//       categoryProducts.find((p) => String(p.id) === String(item.type_id)) ||
//       categoryProducts.find(
//         (p) => (p.item_name_english || p.item_name) === item.type_name
//       );
//     const productId = selectedProduct ? selectedProduct.id : "";

//     // Make sure the dropdown options are ready immediately, don't wait for the effect
//     setFilteredProducts(categoryProducts);

//     const managerObj = userdata.find(
//   (u) => u.user_id === item.manager || u.name === item.manager
// );
//     const managerId = managerObj ? managerObj.id : "";

//     setUpdateData((prev) => ({
//       ...prev,
//       select_category: item.category,
//       select_type: productId,
//       select_type_name: item.type_name,
//       select_type_tamil: selectedProduct?.item_name_tamil || "",
//       quantity: item.quantity,
//       weight: item.weight,
//       rate: item.rate,
//       making_charges: item.making_charges,
//       amount: item.amount,
//       manager: item.manager,
//       staff: item.staff,
//     }));
//     setMakingWastagePercentage(item.making_wastage_percentage || "");
//     setMakingWastageValue(item.making_wastage || "");
//     setStoneValue(item.stone_value || "");
//     setAdjustment(item.adjustment || "");
//     setSelectedAction(item.action_type);
//     setSelectedManager(managerId);
//     setSelectedStaff(item.staff);
//     if (managerId) {
//       const selectedManagerObj = userdata.find(
//         (u) => u.id === parseInt(managerId),
//       );
//       const managerUserId = selectedManagerObj
//         ? selectedManagerObj.user_id
//         : "";
//       setStaffList(
//         Array.isArray(userdata)
//           ? userdata.filter(
//               (user) => user.role === "Employee" || user.role === "employee",
//             )
//           : [],
//       );
//     }

//     setEditingIndex(index);
//     setIsRateManuallyEdited(true);
//     setIsAdjustmentApplied(false); // ✅ allow live recalculation while editing
//   };

//   const handleDeleteItem = (index) => {
//     const updatedItems = items.filter((_, i) => i !== index);
//     setItems(updatedItems);
//   };

//   const handleAddPayment = () => {
//     if (!paymentType || !paymentAmount) {
//       toast.error(
//         "Please select payment type and enter amount",
//         3000,
//         "topRight"
//       );
//       return;
//     }

//     const newPayment = {
//       sales_no: updateData.sales_no,
//       date: new Date().toISOString().split("T")[0],
//       payment_type: paymentType,
//       amount: parseFloat(paymentAmount).toFixed(2),
//     };

//     const updatedPayments = [...payments, newPayment];
//     setPayments(updatedPayments);

//     const totalPaid = updatedPayments.reduce(
//       (sum, payment) => sum + parseFloat(payment.amount || 0),
//       0,
//     );

//     setUpdateData((prev) => ({
//       ...prev,
//       paid: totalPaid.toFixed(2),
//       payment_history: updatedPayments,
//     }));

//     setPaymentType("");
//     setPaymentAmount("");
//   };

//   const handleEditPayment = (index) => {
//     const payment = payments[index];
//     setPaymentType(payment.payment_type);
//     setPaymentAmount(payment.amount);
//     handleDeletePayment(index);
//   };

//   const handleDeletePayment = (index) => {
//     const updatedPayments = payments.filter((_, i) => i !== index);
//     setPayments(updatedPayments);

//     const totalPaid = updatedPayments.reduce(
//       (sum, payment) => sum + parseFloat(payment.amount || 0),
//       0,
//     );

//     setUpdateData((prev) => ({
//       ...prev,
//       paid: totalPaid.toFixed(2),
//       payment_history: updatedPayments,
//     }));
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     if (!updateData.customer_id || !items.length) {
//       toast.error(
//         "Please select a customer and add at least one item",
//         3000,
//         "topRight"
//       );
//       return;
//     }

//     try {
//       const userId = localStorage.getItem("username");
//       const formData = {
//         id: id,
//         sales_no: updateData.sales_no,
//         sales_date: updateData.sales_date,
//         customer_type: updateData.customer_type,
//         customer_id: updateData.customer_id,
//         sub_total: updateData.sub_total,
//         total: updateData.total,
//         discount: updateData.discount,
//         discount_value: updateData.discount_value,
//         round_off: updateData.round_off,
//         tax: updateData.tax,
//         tax_percentage: updateData.tax_percentage,
//         exchange_old_value: updateData.exchange_old_value,
//         net_total: updateData.net_total,
//         paid: updateData.paid,
//         balance: updateData.balance,
//         notes: updateData.notes,
//         manager: updateData.manager,
//         staff: updateData.staff,
//         item_list: items.map((item) => ({
//           sales_no: item.sales_no,
//           category: item.category,
//           item: item.item,
//           type_id: item.type_id,
//           type_name: item.type_name,
//           quantity: item.quantity,
//           weight: item.weight,
//           making_charges: item.making_charges,
//           making_wastage: item.making_wastage,
//           making_wastage_percentage: item.making_wastage_percentage,
//           rate: item.rate,
//           amount: item.amount,
//           action_type: item.action_type,
//           manager: item.manager,
//           staff: item.staff,
//           stone_value: item.stone_value || "0.00",
//           adjustment: item.adjustment || "0.00",
//         })),
//         payment_history: payments,
//         updated_by: userId || "",
//         updated_date: new Date().toISOString(),
//       };

//       const response = await axios.put(
//         `${ApiUrl}/Api/sales.php/${id}`,
//         formData,
//         {
//           headers: { "Content-Type": "application/json" },
//         },
//       );

//       if (response.status === 200) {
//         const notificationResponse = await axios.get(
//           `${ApiUrl}/Api/notification.php?table_id=${id}`,
//         );
//         if (
//           notificationResponse.data?.status &&
//           notificationResponse.data.data?.length > 0
//         ) {
//           const notificationData = notificationResponse.data.data.find(
//             (notif) =>
//               notif.table_id === id.toString() && notif.viewed === "false",
//           );
//           if (notificationData) {
//             await axios.put(
//               `${ApiUrl}/Api/notification.php/${notificationData.id}`,
//               {
//                 id: notificationData.id,
//                 viewed: "true",
//                 updated_by: userId,
//                 updated_date: new Date().toISOString(),
//               },
//               {
//                 headers: { "Content-Type": "application/json" },
//               },
//             );
//           }
//         }
//         toast.success("Sales updated successfully!", 3000, "topRight");
//         navigate("/sales");
//       } else {
//         toast.error(
//           response.data.message || "Failed to update sales data",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Error updating data:", error);
//       toast.error(
//         error.response?.data?.message || "Error updating sales data",
//         3000,
//         "topRight"
//       );
//     }
//   };

//   const handleClear = () => {
//     setUpdateData({
//       sales_no: updateData.sales_no,
//       sales_date: getCurrentDate(),
//       customer_type: "",
//       customer_id: "",
//       sub_total: "0.00",
//       total: "0.00",
//       exchange_old_value: "0.00",
//       discount: "",
//       discount_value: "0.00",
//       tax: "",
//       tax_percentage: "0.00",
//       paid: "0.00",
//       balance: "0.00",
//       notes: "",
//       round_off: "0.00",
//       net_total: "0.00",
//       select_category: "",
//       select_type: "",
//       quantity: "",
//       weight: "",
//       rate: "",
//       making_charges: "",
//       amount: "0.00",
//       manager: "",
//       staff: "",
//       item_list: [],
//       payment_history: [],
//     });
//     setItems([]);
//     setPayments([]);
//     setSelectedAction("New");
//     setCustomerDetails({ name: "", mobile: "" });
//     setSearchTerm("");
//     setMakingWastagePercentage("");
//     setMakingWastageValue("");
//     setStoneValue("");
//     setAdjustment("");
//     setIsAdjustmentApplied(false);
//     setIsRoundOffEnabled(false);
//     setIsRateManuallyEdited(false);
//     setSelectedManager("");
//     setSelectedStaff("");
//     setStaffList([]);
//   };

//   const handlePrint = () => {
//     navigate(`/bill/${updateData.sales_no}`);
//   };

//   const balanceColor =
//     parseFloat(updateData.balance) < 0
//       ? "red"
//       : parseFloat(updateData.balance) > 0
//         ? "green"
//         : "black";

//   return (
//     <>
//       <div className="container-fluid">
//         <div className="row">
//           <div className="col-md-4">
//             <div className="card p-2 shadow-sm mb-2">
//               <div className="row">
//                 <div className="col-md-6">
//                   <label className="form-label">Sales ID</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Sale No"
//                     disabled
//                     value={updateData.sales_no}
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Sales Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={updateData.sales_date}
//                     onChange={(e) =>
//                       setUpdateData({
//                         ...updateData,
//                         sales_date: e.target.value,
//                       })
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-md-8">
//             <div className="card p-2">
//               <div className="row">
//                 <div className="col-md-3">
//                   <label className="form-label">Customer Type</label>
//                   <select
//                     className="form-select"
//                     value={updateData.customer_type}
//                     onChange={(e) => {
//                       const selectedType = e.target.value;
//                       setUpdateData({
//                         ...updateData,
//                         customer_type: selectedType,
//                         customer_id: "",
//                       });
//                       setCustomerDetails({ name: "", mobile: "" });
//                       setSearchTerm("");
//                       fetchCustomer(selectedType);
//                     }}
//                   >
//                     <option value="" disabled>
//                       Customer Type
//                     </option>
//                     <option value="Walk-In">Walk-In</option>
//                     <option value="Retailer">Retailer</option>
//                     <option value="Regular">Regular</option>
//                   </select>
//                 </div>
//                 <div className="col-md-3 position-relative">
//                   <label className="form-label">Customer ID</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Select Customer"
//                     value={searchTerm}
//                     onChange={(e) => {
//                       setSearchTerm(e.target.value);
//                       setShowDropdown(true);
//                     }}
//                     onFocus={() => setShowDropdown(true)}
//                     disabled={!updateData.customer_type}
//                   />
//                   {showDropdown && (
//                     <div className="dropdown-menu show w-100">
//                       {filteredCustomers.length > 0 ? (
//                         filteredCustomers.map((item) => (
//                           <button
//                             key={item._id}
//                             className="dropdown-item"
//                             onClick={() => handleSelectCustomer(item)}
//                           >
//                             {item.customer_id} - {item.name}
//                           </button>
//                         ))
//                       ) : (
//                         <div className="dropdown-item text-muted">
//                           {updateData.customer_type
//                             ? `No ${updateData.customer_type} customers found`
//                             : "Please select customer type first"}
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Customer Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Name"
//                     value={customerDetails.name}
//                     disabled
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Customer Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Mobile Number"
//                     value={customerDetails.mobile}
//                     disabled
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="card card-body">
//           <div className="row mb-3">
//             <div className="col-lg-4 col-md-4">
//               <div className="d-flex mb-2">
//                 <h6 className="m-2">Item</h6>
//                 <div>
//                   {["New", "Exchange", "Po-Sale", "Old Sales"].map((action) => (
//                     <button
//                       key={action}
//                       className={`btn btn-sm me-2 ${
//                         selectedAction === action
//                           ? action === "New"
//                             ? "active-new"
//                             : action === "Exchange"
//                               ? "active-exchange"
//                               : action === "Po-Sale"
//                                 ? "active-posale"
//                                 : "active-oldsales"
//                           : action === "New"
//                             ? "inactive-new btn-secondary"
//                             : action === "Exchange"
//                               ? "inactive-exchange btn-secondary"
//                               : action === "Po-Sale"
//                                 ? "inactive-posale bg-white text-dark border"
//                                 : "inactive-oldsales bg-white text-dark border"
//                       }`}
//                       onClick={() => setSelectedAction(action)}
//                     >
//                       {action}
//                     </button>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-4 col-md-4"></div>
//             {(() => {
//               const role = JSON.parse(localStorage.getItem("user") || "{}").role || "";
//               const isAdmin = role === "Admin" || role === "admin";
//               return (
//                 <>
//                   <div className="col-md-2 col-lg-2">
//                     <label className="form-label">
//                       Manager <span className="text-danger">*</span>
//                     </label>
//                     <select
//                       className="form-select"
//                       value={selectedManager}
//                       onChange={handleManagerChange}
//                     >
//                       <option value="">Select Manager</option>
//                       {userdata
//                         .filter((user) => user.role === "Manager" || user.role === "manager")
//                         .map((manager) => (
//                           <option key={manager.id} value={manager.id}>
//                             {manager.name}
//                           </option>
//                         ))}
//                     </select>
//                   </div>
//                   {!isAdmin && (
//                     <div className="col-md-2 col-lg-2">
//                       <label className="form-label">Staff</label>
//                       <select
//                         className="form-select"
//                         value={selectedStaff}
//                         onChange={handleStaffChange}
//                       >
//                         <option value="">Select Staff</option>
//                         {staffList.map((staff) => (
//                           <option key={staff.id} value={staff.name}>
//                             {staff.name}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   )}
//                 </>
//               );
//             })()}
//           </div>

//           <div className="row">
//             <div className="col-md-2">
//               <label className="form-label">Category</label>
//               <select
//                 className="form-select"
//                 value={updateData.select_category}
//                 onChange={handleCategoryChange}
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//                 <option value="Gold Coin">Gold Coin</option>
//                 <option value="Silver Coin">Silver Coin</option>
//               </select>
//             </div>
//             <div className="col-md-2">
//               <label className="form-label">Item Name</label>
//               <select
//                 className="form-select"
//                 value={updateData.select_type}
//                 onChange={(e) => {
//                   const selectedId = e.target.value;
//                   const selected = filteredProducts.find(
//                     (p) => p.id === parseInt(selectedId),
//                   );
//                   setUpdateData({
//                     ...updateData,
//                     select_type: selectedId,
//                     select_type_name:
//                       selected?.item_name_english || selected?.item_name || "",
//                     select_type_tamil: selected?.item_name_tamil || "",
//                   });

//                   // Stock info toast — only relevant for New / Po-Sale, the
//                   // only modes where the stock check in handleAddItem runs.
//                   if (
//                     selectedId &&
//                     selectedAction !== "Exchange" &&
//                     selectedAction !== "Old Sales" &&
//                     selected
//                   ) {
//                     const stockInfo = getStockStatus(
//                       updateData.select_category,
//                       selected.item_name_english || selected.item_name,
//                       selectedId
//                     );
//                     if (stockInfo.status === "out-of-stock") {
//                       toast.warning("⚠️ This item is currently out of stock!", 3000, "topRight");
//                     } else if (stockInfo.status === "low-stock") {
//                       toast.warning(`⚠️ Only ${stockInfo.available} units left in stock!`, 3000, "topRight");
//                     } else if (stockInfo.itemFound) {
//                       toast.success(`✅ ${stockInfo.available} units available in stock`, 2000, "topRight");
//                     }
//                   }
//                 }}
//                 disabled={!updateData.select_category}
//               >
//                 <option value="" disabled>
//                   Select Item Name
//                 </option>
//                 {filteredProducts.map((product) => {
//                   const stockInfo = getStockStatus(
//                     updateData.select_category,
//                     product.item_name_english || product.item_name,
//                     product.id
//                   );
//                   const stockLabel =
//                     stockInfo.available !== undefined && stockInfo.itemFound
//                       ? ` (Stock: ${stockInfo.available})`
//                       : "";
//                   const stockEmoji =
//                     stockInfo.status === "out-of-stock"
//                       ? " ❌"
//                       : stockInfo.status === "low-stock"
//                       ? " ⚠️"
//                       : "";
//                   return (
//                     <option key={product.id} value={product.id}>
//                       {product.item_name_tamil
//                         ? `${product.item_name_english || product.item_name} / ${product.item_name_tamil}`
//                         : product.item_name_english || product.item_name}
//                       {stockLabel}
//                       {stockEmoji}
//                     </option>
//                   );
//                 })}
//               </select>
//               {!updateData.select_category && filteredProducts.length === 0 && (
//                 <small className="text-muted text-danger">
//                   Please select category first
//                 </small>
//               )}
//             </div>
//             <div className="col-md-2">
//               <label className="form-label">Quantity</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 className="form-control"
//                 placeholder="Quantity"
//                 value={updateData.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*$/.test(value)) {
//                     setUpdateData({ ...updateData, quantity: value });
//                   }
//                 }}
//               />
//             </div>
//             <div className="col-md-2">
//               <label className="form-label">Weight</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Weight (g)"
//                 value={updateData.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d{0,3}$/.test(value)) {
//                     setUpdateData({ ...updateData, weight: value });
//                   }
//                 }}
//               />
//             </div>
//             <div className="col-md-2">
//               <label className="form-label">Rate (Pure %) ₹</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Rate"
//                 value={updateData.rate}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     setUpdateData({ ...updateData, rate: value });
//                     setIsRateManuallyEdited(true);
//                   }
//                 }}
//               />
//             </div>
//           </div>

//           <div className="row">
//             {(selectedAction === "New" || selectedAction === "Po-Sale") && (
//               <>
//                 <div className="col-md-2">
//                   <label className="form-label fw-bold">Stone value ₹</label>
//                   <input
//                     type="text"
//                     inputMode="decimal"
//                     className="form-control"
//                     placeholder="0.00"
//                     value={stoneValue}
//                     onChange={(e) => {
//                       const val = e.target.value;
//                       if (/^\d*\.?\d*$/.test(val) || val === "") {
//                         setStoneValue(val);
//                       }
//                     }}
//                   />
//                 </div>
//                 <div className="col-md-2">
//                   <label className="form-label">Making Charge ₹</label>
//                   <input
//                     type="text"
//                     inputMode="decimal"
//                     className="form-control"
//                     placeholder="Making Charges"
//                     value={updateData.making_charges}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (/^\d*\.?\d*$/.test(value)) {
//                         setUpdateData({
//                           ...updateData,
//                           making_charges: value,
//                         });
//                       }
//                     }}
//                   />
//                 </div>
//                 <div className="col-md-2">
//                   <label className="form-label">Wastage (%)</label>
//                   <input
//                     type="text"
//                     inputMode="decimal"
//                     className="form-control"
//                     placeholder="Wastage %"
//                     value={makingWastagePercentage}
//                     onChange={handleMakingWastagePercentageChange}
//                   />
//                 </div>
//                 <div className="col-md-2">
//                   <label className="form-label">Wastage Value ₹</label>
//                   <input
//                     type="text"
//                     inputMode="decimal"
//                     className="form-control"
//                     placeholder="Wastage Value"
//                     value={makingWastageValue}
//                     onChange={handleMakingWastageValueChange}
//                   />
//                 </div>
//               </>
//             )}
//             {selectedAction === "Exchange" && renderAdjustmentInput()}
//             <div className="col-md-2">
//               <label className="form-label">Amount ₹</label>
//               <input
//                 type="tel"
//                 className="form-control"
//                 placeholder="Amount"
//                 value={updateData.amount}
//                 readOnly
//               />
//             </div>
//             <div className="col-md-1">
//               <button
//                 className={`btn btn-sm mt-4 ${
//                   editingIndex === null ? "btn-success" : "btn-info"
//                 }`}
//                 onClick={handleAddItem}
//               >
//                 <i
//                   className={`bi ${
//                     editingIndex === null ? "bi-plus" : "bi-check"
//                   }`}
//                 ></i>
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="container-fluid mt-2">
//           <div className="row">
//             <div className="col-lg-8">
//               <div className="card card-body">
//                 <h6>Item List</h6>
//                 <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                   <table className="table table-layout-fixed w-100">
//                     <thead className="bg-light">
//                       <tr>
//                         <th>S.No</th>
//                         <th>Category</th>
//                         <th>ItemName</th>
//                         <th>Qty</th>
//                         <th>Wgt (g)</th>
//                         <th>Stone Value ₹</th>
//                         <th>MC ₹</th>
//                         <th>Rate ₹</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {items.length > 0 ? (
//                         items.map((item, index) => (
//                           <tr key={index}>
//                             <td>{index + 1}</td>
//                             <td>{item.category}</td>
//                             <td>
//                               {item.type_name_tamil
//                                 ? `${item.type_name} / ${item.type_name_tamil}`
//                                 : item.type_name}
//                             </td>
//                             <td>{item.quantity}</td>
//                             <td>{item.weight} (g)</td>
//                             <td>{item.stone_value || "-"}</td>
//                             <td>{item.making_charges || "-"}</td>
//                             <td>{item.rate}</td>
//                             <td>
//                               <button
//                                 className="btn btn-sm btn-primary me-1"
//                                 onClick={() => handleEditItem(index)}
//                               >
//                                 <i className="bi bi-pencil"></i>
//                               </button>
//                               <button
//                                 className="btn btn-sm btn-danger"
//                                 onClick={() => handleDeleteItem(index)}
//                               >
//                                 <i className="bi bi-trash"></i>
//                               </button>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td colSpan="9" className="text-center">
//                             No items added
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                   <div className="row">
//                     <div className="col-lg-8"></div>
//                     <div className="col-lg-4">
//                       <div className="d-flex">
//                         <h6 className="mt-2">Total: </h6>
//                         <input
//                           className="form-control mx-2"
//                           value={updateData.total}
//                           readOnly
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-lg-4 mb-5">
//               <div className="card p-3">
//                 <div className="row">
//                   <div className="col-md-4">
//                     <label className="form-label">Discount (%)</label>
//                   </div>
//                   <div className="col-md-4">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={updateData.discount}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           discount: e.target.value.replace(/\D/g, ""),
//                         })
//                       }
//                     />
//                   </div>
//                   <div className="col-md-4">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={updateData.discount_value}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Sub Total</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={updateData.sub_total}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-md-4">
//                     <label className="form-label">GST (%)</label>
//                   </div>
//                   <div className="col-md-4">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={updateData.tax}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           tax: e.target.value.replace(/\D/g, ""),
//                         })
//                       }
//                     />
//                   </div>
//                   <div className="col-md-4">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={updateData.tax_percentage}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-md-4">
//                     <label className="form-label">Round Off</label>
//                   </div>
//                   <div className="col-md-2">
//                     <input
//                       type="checkbox"
//                       checked={isRoundOffEnabled}
//                       onChange={(e) => setIsRoundOffEnabled(e.target.checked)}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={updateData.round_off}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Net Total</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={updateData.net_total}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Exchange Old</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={updateData.exchange_old_value}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mb-2 d-flex justify-content-center">
//                   <button
//                     className="btn btn-success btn-sm w-50"
//                     onClick={() => setInfoModal(true)}
//                   >
//                     Add Payment +
//                   </button>
//                 </div>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Paid</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={updateData.paid}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Balance</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={Math.abs(parseFloat(updateData.balance)).toFixed(
//                         2,
//                       )}
//                       readOnly
//                       style={{ color: balanceColor }}
//                     />
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Notes</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.notes}
//                       onChange={(e) =>
//                         setUpdateData({ ...updateData, notes: e.target.value })
//                       }
//                     />
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-between mb-3">
//                  <button className="btn btn-secondary btn-sm" onClick={goBackToOrigin}>
//   <i className="fa-solid fa-arrow-left"></i> Back
// </button>
//                   <button
//                     className="btn btn-danger btn-sm"
//                     onClick={handleClear}
//                   >
//                     <i className="bi bi-x-circle"></i> Clear
//                   </button>
//                   <button
//                     className="btn btn-primary btn-sm"
//                     onClick={() => setShowModal(true)}
//                   >
//                     <i className="bi bi-printer"></i> Estimate
//                   </button>
//                   <button
//                     className="btn btn-success btn-sm"
//                     onClick={handleUpdate}
//                   >
//                     <i className="bi bi-save"></i> Update
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div
//           className={`modal fade ${infoModal ? "show" : ""}`}
//           style={{ display: infoModal ? "block" : "none" }}
//           tabIndex="-1"
//           aria-labelledby="addPaymentModalLabel"
//           aria-hidden={!infoModal}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h6
//                   className="modal-title text-primary"
//                   id="addPaymentModalLabel"
//                 >
//                   Add Payment
//                 </h6>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   style={{ fontSize: "10px" }}
//                   onClick={() => setInfoModal(false)}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <p>
//                       Balance:{" "}
//                       <span className="mx-3 text-success">
//                         {Math.abs(parseFloat(updateData.balance)).toFixed(2)}
//                       </span>
//                     </p>
//                   </div>
//                   <div className="col-lg-6">
//                     <p>
//                       Paid:{" "}
//                       <span className="mx-3 text-primary">
//                         {updateData.paid}
//                       </span>
//                     </p>
//                   </div>
//                   <div className="col-lg-6">
//                     <select
//                       className="form-select"
//                       value={paymentType}
//                       onChange={(e) => setPaymentType(e.target.value)}
//                     >
//                       <option value="">Select Paytype</option>
//                       <option value="Cash">Cash</option>
//                       <option value="Gpay">Gpay</option>
//                       <option value="Phonepe">Phonepe</option>
//                       <option value="Paytm">Paytm</option>
//                       <option value="Credit">Credit</option>
//                       <option value="Debit">Debit</option>
//                     </select>
//                   </div>
//                   <div className="col-lg-4">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       value={paymentAmount}
//                       onChange={(e) => setPaymentAmount(e.target.value)}
//                       placeholder="Enter Amount"
//                     />
//                   </div>
//                   <div className="col-lg-2">
//                     <button
//                       className="btn btn-primary btn-sm"
//                       onClick={handleAddPayment}
//                     >
//                       Add +
//                     </button>
//                   </div>
//                 </div>
//                 <div
//                   className="card mt-3"
//                   style={{ borderRadius: "5px", backgroundColor: "#E8F0FA" }}
//                 >
//                   <div className="card-body">
//                     <div className="table-responsive">
//                       <table className="table table-border">
//                         <thead>
//                           <tr>
//                             <th>S.No</th>
//                             <th>Pay Type</th>
//                             <th>Paid Amount</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {payments.length > 0 ? (
//                             payments.map((payment, index) => (
//                               <tr key={index}>
//                                 <td>{index + 1}</td>
//                                 <td>{payment.payment_type}</td>
//                                 <td>{payment.amount}</td>
//                                 <td>
//                                   <button
//                                     className="btn btn-light btn-sm me-2"
//                                     onClick={() => handleEditPayment(index)}
//                                   >
//                                     <i className="bi bi-pencil text-info"></i>
//                                   </button>
//                                   <button
//                                     className="btn btn-light btn-sm me-2"
//                                     onClick={() => handleDeletePayment(index)}
//                                   >
//                                     <i className="bi bi-trash text-danger"></i>
//                                   </button>
//                                 </td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="4" className="text-center">
//                                 No payments added
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="text-end mt-2">
//                   <button
//                     className="btn btn-success btn-sm"
//                     onClick={() => setInfoModal(false)}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div
//           className={`modal fade ${showModal ? "show" : ""}`}
//           style={{ display: showModal ? "block" : "none" }}
//           tabIndex="-1"
//           aria-labelledby="printModalLabel"
//           aria-hidden={!showModal}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h6 className="modal-title text-primary" id="printModalLabel">
//                   Print (If You Want Print or Not?)
//                 </h6>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   style={{ fontSize: "10px" }}
//                   onClick={() => setShowModal(false)}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <form>
//                   <div className="text-center">
//                     <p className="text-center">
//                       If you want Print the sales Bill ?
//                     </p>
//                   </div>
//                   <div className="d-flex justify-content-center mt-4">
//                     <button
//                       type="button"
//                       className="btn btn-secondary btn-sm mx-2"
//                       onClick={() => navigate("/sales")}
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="button"
//                       className="btn btn-primary btn-sm"
//                       onClick={handlePrint}
//                     >
//                       Print
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>

//         {(showModal || infoModal) && (
//           <div className="modal-backdrop fade show"></div>
//         )}
//       </div>
//     </>
//   );
// }

// export default UpdateSales;
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams, useLocation  } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import { RatesContext } from "../Pages/RatesContext";
import { useToast } from "../Toast/ToastContext";

function UpdateSales({ toggleSidebar }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // NEW
  const toast = useToast();
  const [navSource, setNavSource] = useState(null); // NEW
  const { rates } = useContext(RatesContext) || {
    rates: { gold_1g_rate: "", silver_10g_rate: "", cold_coin_rate: "" },
  };

  // State declarations
  const [showModal, setShowModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState("New");
  const [paymentType, setPaymentType] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [payments, setPayments] = useState([]);
  const [customerDetails, setCustomerDetails] = useState({
    name: "",
    mobile: "",
  });
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [customerGetting, setCustomerGetting] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [items, setItems] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [dailyRatesGetting, setDailyRatesGetting] = useState([]);
  const [makingWastagePercentage, setMakingWastagePercentage] = useState("");
  const [makingWastageValue, setMakingWastageValue] = useState("");
  const [isRoundOffEnabled, setIsRoundOffEnabled] = useState(false);
  const [isRateManuallyEdited, setIsRateManuallyEdited] = useState(false);
  const [userdata, setUserdata] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [staffList, setStaffList] = useState([]);

  // Stone value / Adjustment (matches AddSales item structure)
  const [stoneValue, setStoneValue] = useState("");
  const [adjustment, setAdjustment] = useState("");
  const [isAdjustmentApplied, setIsAdjustmentApplied] = useState(false);

  // Stock Data State (matches AddSales)
  const [stockData, setStockData] = useState([]);
  const [stockLoading, setStockLoading] = useState(false);

  // Customer Sales History State (matches UpdatePurchase's supplier
  // payment history pattern — same customer AND same bill date, excludes
  // the bill currently being edited)
  const [customerSalesHistory, setCustomerSalesHistory] = useState([]);
  const [loadingSalesHistory, setLoadingSalesHistory] = useState(false);

  const [updateData, setUpdateData] = useState({
    sales_no: "",
    sales_date: getCurrentDate(),
    customer_type: "",
    customer_id: "",
    sub_total: "0.00",
    total: "0.00",
    exchange_old_value: "0.00",
    discount: "",
    discount_value: "0.00",
    tax: "",
    tax_percentage: "0.00",
    paid: "0.00",
    balance: "0.00",
    notes: "",
    round_off: "0.00",
    net_total: "0.00",
    select_category: "",
    select_type: "",
    quantity: "",
    weight: "",
    rate: "",
    making_charges: "",
    amount: "0.00",
    manager: "", // Store manager user_id
    staff: "", // Store staff name
    item_list: [],
    payment_history: [],
  });

  // Get current date in YYYY-MM-DD format
  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // Format date to DD-MM-YYYY
  function formatDateToDDMMYYYY(dateString) {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  }

  // ==================== STOCK FUNCTIONS ====================

  // Fetch stock data
  const fetchStockData = async () => {
    try {
      setStockLoading(true);
      const response = await axios.get(`${ApiUrl}/Api/stock.php`);
      const data = Array.isArray(response.data?.data) ? response.data.data : [];
      setStockData(data);
    } catch (error) {
      console.error("Error fetching stock data:", error.message);
      toast.error("Failed to fetch stock data", 3000, "topRight");
      setStockData([]);
    } finally {
      setStockLoading(false);
    }
  };

  // Check stock availability for a specific item — compares WEIGHT (grams)
  // against the stock's avaliable_weight, not piece quantity. Matches
  // AddSales' behavior exactly.
  const checkStockAvailability = (category, itemName, weight, selectedTypeId) => {
    let stockItem = null;

    if (selectedTypeId) {
      const selectedProduct = products.find(
        (p) => String(p.id) === String(selectedTypeId)
      );

      if (selectedProduct) {
        const productName = selectedProduct.item_name_english || selectedProduct.item_name;
        stockItem = stockData.find(
          (item) =>
            item.category?.toLowerCase() === category?.toLowerCase() &&
            (item.item?.toLowerCase() === productName?.toLowerCase() ||
              item.item_name_english?.toLowerCase() === productName?.toLowerCase())
        );

        if (!stockItem) {
          stockItem = stockData.find(
            (item) =>
              item.category?.toLowerCase() === category?.toLowerCase() &&
              (item.item?.toLowerCase().includes(productName?.toLowerCase()) ||
                item.item_name_english?.toLowerCase().includes(productName?.toLowerCase()))
          );
        }
      }
    }

    if (!stockItem && itemName) {
      stockItem = stockData.find(
        (item) =>
          item.category?.toLowerCase() === category?.toLowerCase() &&
          (item.item?.toLowerCase() === itemName?.toLowerCase() ||
            item.item_name_english?.toLowerCase() === itemName?.toLowerCase())
      );
    }

    if (!stockItem && selectedAction === "Exchange") {
      stockItem = stockData.find(
        (item) => item.category?.toLowerCase() === category?.toLowerCase()
      );
    }

    if (!stockItem) {
      console.warn("Item not found in stock:", { category, itemName, selectedTypeId });

      // A product must exist in the general stock before it can be sold,
      // regardless of action type (New, Po-Sale, etc.).
      return {
        available: false,
        message: "This product is not present in general stock. Please add it to stock before selling.",
        availableWeight: 0,
        itemFound: false,
      };
    }

    // avaliable_weight comes back as a string like "123.456g" — strip the
    // trailing "g" before parsing. Fall back to the item's total weight
    // field if avaliable_weight isn't present for some reason.
    const availableWeight = parseFloat(
      String(stockItem.avaliable_weight ?? stockItem.weight ?? "0").replace(/g$/i, "")
    ) || 0;
    const requestedWeight = parseFloat(weight) || 0;

    if (requestedWeight > availableWeight) {
      return {
        available: false,
        message: `Only ${availableWeight.toFixed(3)}g available. Requested: ${requestedWeight.toFixed(3)}g`,
        availableWeight,
        itemFound: true,
        stockItem: stockItem,
      };
    }

    return {
      available: true,
      message: "Stock available",
      availableWeight,
      itemFound: true,
      stockItem: stockItem,
    };
  };

  // Get stock status for display — based on WEIGHT (grams) available.
  const getStockStatus = (category, itemName, selectedTypeId) => {
    let stockItem = null;

    if (selectedTypeId) {
      const selectedProduct = products.find(
        (p) => String(p.id) === String(selectedTypeId)
      );

      if (selectedProduct) {
        const productName = selectedProduct.item_name_english || selectedProduct.item_name;
        stockItem = stockData.find(
          (item) =>
            item.category?.toLowerCase() === category?.toLowerCase() &&
            (item.item?.toLowerCase() === productName?.toLowerCase() ||
              item.item_name_english?.toLowerCase() === productName?.toLowerCase())
        );

        if (!stockItem) {
          stockItem = stockData.find(
            (item) =>
              item.category?.toLowerCase() === category?.toLowerCase() &&
              (item.item?.toLowerCase().includes(productName?.toLowerCase()) ||
                item.item_name_english?.toLowerCase().includes(productName?.toLowerCase()))
          );
        }
      }
    }

    if (!stockItem && itemName) {
      stockItem = stockData.find(
        (item) =>
          item.category?.toLowerCase() === category?.toLowerCase() &&
          (item.item?.toLowerCase() === itemName?.toLowerCase() ||
            item.item_name_english?.toLowerCase() === itemName?.toLowerCase())
      );
    }

    if (!stockItem) {
      return { status: "unknown", available: 0, itemFound: false };
    }

    const available = parseFloat(
      String(stockItem.avaliable_weight ?? stockItem.weight ?? "0").replace(/g$/i, "")
    ) || 0;
    let status = "available";
    if (available === 0) status = "out-of-stock";
    else if (available < 5) status = "low-stock"; // low-stock threshold in grams

    return { status, available, itemFound: true };
  };

    useEffect(() => {
    if (location.state?.source === "blue-page") {
      setNavSource({
        selectedRowId: location.state.selectedRowId,
        returnTab: location.state.returnTab,
      });
    }
  }, [location.state]);

  const goBackToOrigin = () => {
    if (navSource) {
      navigate("/balance/blue-page-balance", { // ⬅ swap in your actual route path for BluePageBalance
        state: {
          from: "balance-page",
          selectedRowId: navSource.selectedRowId,
          returnTab: navSource.returnTab,
        },
      });
    } else {
      navigate("/sales");
    }
  };

  // ==================== END STOCK FUNCTIONS ====================

  // ==================== CUSTOMER SALES HISTORY ====================
  // Same pattern as UpdatePurchase's supplier payment history: only show
  // this customer's OTHER bills that share the SAME date as the bill
  // currently being edited, not their entire sales history, and exclude
  // the bill being edited itself.
  useEffect(() => {
    if (!updateData.customer_id || !updateData.sales_date) {
      setCustomerSalesHistory([]);
      return;
    }

    const fetchSalesHistory = async () => {
      setLoadingSalesHistory(true);
      try {
        const res = await axios.get(`${ApiUrl}/Api/sales.php`);
        const allSales = res.data?.data || [];

        // Compare only the DATE portion (first 10 chars, "YYYY-MM-DD").
        // sales_date can come back with a time component on some records
        // (e.g. "2026-07-17 10:23:00"), and a full-string match would
        // silently drop those bills out of the comparison even though
        // they're on the same calendar day.
        const currentDateOnly = (updateData.sales_date || "").slice(0, 10);

        const history = allSales
          .filter((s) => {
            const recordDateOnly = (s.sales_date || "").slice(0, 10);
            return (
              String(s.customer_id).trim() === String(updateData.customer_id).trim() &&
              recordDateOnly === currentDateOnly &&
              // NOTE: the route param `id` here is actually the sales_no
              // string (see BluePageBalance's navigate(`/update-sales/${item.sales_no}`)),
              // not the numeric database id. Comparing against s.id would
              // never exclude the current bill, since a numeric id can
              // never equal a "TJS-xxx" string.
              String(s.sales_no).trim() !== String(id).trim()
            );
          })
          .sort((a, b) => new Date(b.sales_date) - new Date(a.sales_date));

        setCustomerSalesHistory(history);
      } catch (error) {
        console.error("Error fetching customer sales history:", error.message);
        setCustomerSalesHistory([]);
      } finally {
        setLoadingSalesHistory(false);
      }
    };

    fetchSalesHistory();
  }, [updateData.customer_id, updateData.sales_date, id]);
  // ==================== END CUSTOMER SALES HISTORY ====================

  // Fetch initial data
  useEffect(() => {
    toggleSidebar();
    fetchProducts();
    fetchCustomer();
    fetchDailyRatesData();
    fetchuserdata();
    fetchStockData(); // Fetch stock data on component mount
  }, [id]);

  // Refresh stock data periodically (matches AddSales)
  useEffect(() => {
    const interval = setInterval(() => {
      fetchStockData();
    }, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (id && userdata.length > 0) {
      fetchSalesData();
    }
  }, [id, userdata]);

  const fetchuserdata = async () => {
    try {
      const fetchuser = await axios.get(`${ApiUrl}/Api/user.php`);
      const userDataArray = Array.isArray(fetchuser.data.data)
        ? fetchuser.data.data
        : [];
      setUserdata(userDataArray);
    } catch (error) {
      console.error("Error fetching user data:", error);
      setUserdata([]);
      toast.error("Failed to fetch user data", 3000, "topRight");
    }
  };

  const handleManagerChange = (e) => {
    const managerId = e.target.value;
    setSelectedManager(managerId);

    if (managerId) {
      const selectedManagerObj = userdata.find(
        (user) => user.id === parseInt(managerId),
      );
      const managerUserId = selectedManagerObj
        ? selectedManagerObj.user_id
        : "";
      const allStaff = userdata.filter(
        (user) => user.role === "Employee" || user.role === "employee",
      );
      setStaffList(allStaff);
      setUpdateData((prev) => ({
        ...prev,
        manager: managerUserId, // Store manager user_id (e.g., "MG-001")
      }));
    } else {
      setUpdateData((prev) => ({
        ...prev,
        manager: "",
      }));
    }
  };

  const handleStaffChange = (e) => {
    const staffName = e.target.value;
    setSelectedStaff(staffName);
    setUpdateData((prev) => ({
      ...prev,
      staff: staffName, // Store staff name
    }));
  };

  const fetchDailyRatesData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/daily_rates.php`);
      setDailyRatesGetting(response.data.data || []);
    } catch (error) {
      console.error("Error fetching daily rates:", error.message);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/product.php`);
      setProducts(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching products:", error.message);
      setProducts([]);
    }
  };

  const fetchCustomer = async (customerType = "") => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/customer.php`);
      const data = response.data?.data || [];
      const filtered = customerType
        ? data.filter((customer) => customer.customer_type === customerType)
        : data;
      setCustomerGetting(filtered);
    } catch (error) {
      console.error("Error fetching customers:", error.message);
      setCustomerGetting([]);
    }
  };

  const fetchSalesData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/sales.php/${id}`);
      if (response.data && response.data.data) {
        const salesData = response.data.data[0];

        if (salesData.customer_id) {
          const customerResponse = await axios.get(
            `${ApiUrl}/Api/customer.php/${salesData.customer_id}`,
          );
          if (customerResponse.data && customerResponse.data.data) {
            const customer = customerResponse.data.data[0];
            setCustomerDetails({
              name: customer.name,
              mobile: customer.mobile,
            });
            setSearchTerm(`${customer.customer_id} - ${customer.name}`);
          }
        }

        // Find manager and set selectedManager
        const managerObj = userdata.find(
          (u) => u.user_id === salesData.manager,
        );
        const managerId = managerObj ? managerObj.id : "";
        setSelectedManager(managerId);

        // Set staff list based on manager
        if (managerId) {
          const selectedManagerObj = userdata.find(
            (u) => u.id === parseInt(managerId),
          );
          const managerUserId = selectedManagerObj
            ? selectedManagerObj.user_id
            : "";
          setStaffList(
            Array.isArray(userdata)
              ? userdata.filter(
                  (user) => user.role === "Employee" || user.role === "employee",
                )
              : [],
          );
        }

        setSelectedStaff(salesData.staff || "");

        setUpdateData({
          sales_no: salesData.sales_no || "",
          sales_date: salesData.sales_date || getCurrentDate(),
          customer_type: salesData.customer_type || "",
          customer_id: salesData.customer_id || "",
          sub_total: salesData.sub_total || "0.00",
          total: salesData.total || "0.00",
          tax: salesData.tax || "",
          tax_percentage: salesData.tax_percentage || "0.00",
          net_total: salesData.net_total || "0.00",
          discount: salesData.discount || "",
          discount_value: salesData.discount_value || "0.00",
          paid: salesData.paid || "0.00",
          balance: salesData.balance || "0.00",
          notes: salesData.notes || "",
          round_off: salesData.round_off || "0.00",
          exchange_old_value: salesData.exchange_old_value || "0.00",
          select_category: "",
          select_type: "",
          quantity: "",
          weight: "",
          rate: "",
          making_charges: "",
          amount: "0.00",
          manager: salesData.manager || "",
          staff: salesData.staff || "",
          item_list: salesData.item_list || [],
          payment_history: salesData.payment_history || [],
        });

        if (salesData.item_list && Array.isArray(salesData.item_list)) {
          setItems(
            salesData.item_list.map((item) => ({
              sales_no: item.sales_no || salesData.sales_no,
              category: item.category || "",
              item: item.item || "",
              type_id: item.type_id || "",
              type_name:
                item.type_name ||
                item.item ||
                (item.action_type === "Exchange" ? `Old ${item.category}` : ""),
              type_name_tamil: item.type_name_tamil || "",
              quantity: item.quantity || "",
              weight: item.weight || "",
              making_charges: item.making_charges || "",
              making_wastage: item.making_wastage || "",
              making_wastage_percentage: item.making_wastage_percentage || "",
              rate: item.rate || "",
              amount: item.amount || "0.00",
              action_type: item.action_type || "New",
              manager: item.manager || salesData.manager || "",
              staff: item.staff || salesData.staff || "",
              stone_value: item.stone_value || "0.00",
              adjustment: item.adjustment || "0.00",
            })),
          );

          const uniqueActions = [
            ...new Set(salesData.item_list.map((item) => item.action_type)),
          ];
          if (uniqueActions.length === 1) {
            setSelectedAction(uniqueActions[0] || "New");
          }
        }

        if (
          salesData.payment_history &&
          Array.isArray(salesData.payment_history)
        ) {
          setPayments(salesData.payment_history);
        }

        setIsRoundOffEnabled(salesData.round_off !== "0.00");
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
      toast.error("Failed to load sales data", 3000, "topRight");
    }
  };

  // Filter customers based on search term
  useEffect(() => {
    const filtered = customerGetting.filter(
      (customer) =>
        customer.customer_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        customer.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    setFilteredCustomers(filtered);
  }, [searchTerm, customerGetting]);

  const handleSelectCustomer = (customer) => {
    setUpdateData((prev) => ({
      ...prev,
      customer_id: customer.customer_id,
      customer_type: customer.customer_type,
    }));
    setCustomerDetails({
      name: customer.name,
      mobile: customer.mobile,
    });
    setSearchTerm(`${customer.customer_id} - ${customer.name}`);
    setShowDropdown(false);
  };

  // ===================================================================
  // Calculate item amount — matches AddSales: purity-adjusted, includes
  // stone value for New/Po-Sale, and is gated by isAdjustmentApplied so
  // a manual Exchange adjustment isn't silently overwritten. Editing an
  // item resets isAdjustmentApplied to false (see handleEditItem) so the
  // amount keeps recalculating live while you edit, instead of freezing.
  // ===================================================================
  useEffect(() => {
    if (!updateData.quantity || !updateData.weight || !updateData.rate) {
      setUpdateData((prev) => ({ ...prev, amount: "0.00" }));
      return;
    }
    if (isAdjustmentApplied) return;

    // NOTE: updateData.rate already has the selected product's Pure %
    // baked in (see the Rate auto-fill effect below), so amount is
    // now just quantity x weight x rate — no separate purity multiply.
    let baseAmount =
      parseFloat(updateData.quantity) *
      parseFloat(updateData.weight) *
      parseFloat(updateData.rate);

    if (selectedAction === "New" && updateData.making_charges) {
      baseAmount += parseFloat(updateData.making_charges);
    }
    if (makingWastageValue) {
      const wastage = parseFloat(makingWastageValue);
      if (selectedAction === "Exchange") {
        baseAmount -= wastage;
      } else {
        baseAmount += wastage;
      }
    }
    if (
      (selectedAction === "New" || selectedAction === "Po-Sale") &&
      stoneValue
    ) {
      baseAmount += parseFloat(stoneValue);
    }

    setUpdateData((prev) => ({ ...prev, amount: baseAmount.toFixed(2) }));
  }, [
    updateData.quantity,
    updateData.weight,
    updateData.rate,
    updateData.making_charges,
    makingWastageValue,
    selectedAction,
    isAdjustmentApplied,
    stoneValue,
    updateData.select_type,
    products,
  ]);

  // Adjustment is entered as a WEIGHT (g). The ₹ impact of the adjustment
  // (weight × rate) is what moves the amount — the item's actual weight
  // itself is never touched. "−" reduces (less) the amount by weight ×
  // rate; "+" adds it back (e.g. to undo/correct). We keep the WEIGHT (not
  // the ₹ value) in `adjustment` / item.adjustment so the UI can display
  // "Adj: -0.500 g" etc.
  const applyAdjustment = (sign) => {
    const adjustmentWeight = parseFloat(adjustment) || 0;
    if (adjustmentWeight === 0) return;
    const rate = parseFloat(updateData.rate) || 0;
    const signedWeight = sign === "+" ? adjustmentWeight : -adjustmentWeight;
    const adjustmentAmount = signedWeight * rate;
    const currentAmount = parseFloat(updateData.amount) || 0;
    const newAmount = currentAmount + adjustmentAmount;
    setUpdateData((prev) => ({ ...prev, amount: newAmount.toFixed(2) }));
    setIsAdjustmentApplied(true);
    setAdjustment(signedWeight.toFixed(3));
  };

  const renderAdjustmentInput = () => (
    <div className="col-md-2">
      <label className="form-label">Adjustment Wgt (g)</label>
      <div className="input-group">
        <button
          type="button"
          className="btn btn-outline-danger btn-sm"
          style={{ height: "34px" }}
          onClick={() => applyAdjustment("-")}
          title="Reduce amount by weight × rate"
        >
          –
        </button>
        <input
          type="text"
          className="form-control"
          placeholder="0.000"
          value={adjustment}
          onChange={(e) => {
            if (/^\d*\.?\d{0,3}$/.test(e.target.value) || e.target.value === "")
              setAdjustment(e.target.value);
          }}
        />
        <button
          type="button"
          className="btn btn-outline-success btn-sm"
          style={{ height: "34px" }}
          onClick={() => applyAdjustment("+")}
          title="Add back weight × rate"
        >
          +
        </button>
      </div>
    </div>
  );

  // Calculate totals
  useEffect(() => {
    const subtotal = items
      .filter((item) => item.action_type !== "Exchange")
      .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
    setUpdateData((prev) => ({
      ...prev,
      total: subtotal.toFixed(2),
      sub_total: subtotal.toFixed(2),
    }));
  }, [items]);

  // Calculate discount, tax, round-off, net total, exchange_old_value, and balance
  useEffect(() => {
    const total = parseFloat(updateData.total) || 0;
    const discountPercentage = parseFloat(updateData.discount) || 0;
    const taxPercentage = parseFloat(updateData.tax) || 0;
    const exchangeOldValue = items
      .filter((item) => item.action_type === "Exchange")
      .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

    const discountAmount = (total * discountPercentage) / 100;
    const subtotal = total - discountAmount;
    const taxAmount = (subtotal * taxPercentage) / 100;
    let netTotal = subtotal + taxAmount;

    let roundOffValue = 0;
    if (isRoundOffEnabled) {
      const decimalPart = netTotal - Math.floor(netTotal);
      if (decimalPart < 0.5) {
        roundOffValue = -decimalPart;
        netTotal = Math.floor(netTotal);
      } else {
        roundOffValue = 1 - decimalPart;
        netTotal = Math.ceil(netTotal);
      }
    }

    let balance =
      netTotal - exchangeOldValue - parseFloat(updateData.paid || 0);
    if (total === 0) {
      balance = parseFloat(updateData.paid || 0) - exchangeOldValue;
    }

    setUpdateData((prev) => ({
      ...prev,
      discount_value: discountAmount.toFixed(2),
      sub_total: subtotal.toFixed(2),
      tax_percentage: taxAmount.toFixed(2),
      exchange_old_value: exchangeOldValue.toFixed(2),
      net_total: netTotal.toFixed(2),
      round_off: roundOffValue.toFixed(2),
      balance: balance.toFixed(2),
    }));
  }, [
    updateData.total,
    updateData.discount,
    updateData.tax,
    isRoundOffEnabled,
    updateData.paid,
    items,
  ]);

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    let rate = "";
    setIsRateManuallyEdited(false);

    const today = formatDateToDDMMYYYY(getCurrentDate());
    const todayRate =
      dailyRatesGetting.find((rate) => rate.date === today) || {};

    if (selectedCategory === "Gold") {
      if (selectedAction === "Old Sales") {
        rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
      } else if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = todayRate.gold_1g_rate || rates.gold_1g_rate || "";
      }
    } else if (selectedCategory === "Silver") {
      if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = (
          parseFloat(todayRate.silver_10g_rate) ||
          parseFloat(rates.silver_10g_rate) ||
          ""
        ).toString();
      }
    } else if (selectedCategory === "Gold Coin") {
      if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
      }
    } else if (selectedCategory === "Silver Coin") {
      if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = todayRate.silver_coin_rate || rates.silver_coin_rate || "";
      }
    }

    setUpdateData((prev) => ({
      ...prev,
      select_category: selectedCategory,
      select_type: "",
      rate,
    }));
  };

  // Reset rate when action changes
  useEffect(() => {
    if (isRateManuallyEdited && selectedAction === "Exchange") {
      return;
    }

    let rate = "";
    const today = formatDateToDDMMYYYY(getCurrentDate());
    const todayRate =
      dailyRatesGetting.find((r) => r.date === today) || {};

    if (updateData.select_category === "Gold") {
      if (selectedAction === "Old Sales") {
        rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
      } else if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = todayRate.gold_1g_rate || rates.gold_1g_rate || "";
      }
    } else if (updateData.select_category === "Silver") {
      if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = todayRate.silver_10g_rate
          ? todayRate.silver_10g_rate
          : rates.silver_10g_rate
            ? rates.silver_10g_rate
            : "";
      }
    } else if (updateData.select_category === "Gold Coin") {
      if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
      }
    } else if (updateData.select_category === "Silver Coin") {
      if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = todayRate.silver_coin_rate || rates.silver_coin_rate || "";
      }
    }

    // Apply the selected product's purity (Pure %) to today's market
    // rate, so the Rate field shown/stored on the item is the actual
    // sale rate for that specific product, not just the raw market rate.
    if (rate && updateData.select_type && selectedAction !== "Exchange") {
      const selectedProductForRate = products.find(
        (p) => String(p.id) === String(updateData.select_type)
      );
      if (selectedProductForRate?.pure_percent) {
        const purity = parseFloat(selectedProductForRate.pure_percent) / 100;
        rate = (parseFloat(rate) * purity).toFixed(2);
      }
    }

    setUpdateData((prev) => ({
      ...prev,
      rate,
    }));
  }, [
    selectedAction,
    updateData.select_category,
    updateData.select_type,
    dailyRatesGetting,
    rates,
    isRateManuallyEdited,
    products,
  ]);

  // Filter products based on selected category
  useEffect(() => {
    if (updateData.select_category) {
      const filtered = products.filter(
        (product) => product.category === updateData.select_category,
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  }, [updateData.select_category, products]);

  const handleMakingWastagePercentageChange = (e) => {
    const percentage = e.target.value;
    if (/^\d*\.?\d{0,2}$/.test(percentage)) {
      setMakingWastagePercentage(percentage);
      setMakingWastageValue("");
      if (
        updateData.quantity &&
        updateData.weight &&
        updateData.rate &&
        percentage
      ) {
        const baseAmount =
          parseFloat(updateData.quantity) *
          parseFloat(updateData.weight) *
          parseFloat(updateData.rate);
        const wastageValue = (baseAmount * parseFloat(percentage)) / 100;
        setMakingWastageValue(wastageValue.toFixed(2));
      }
    }
  };

  const handleMakingWastageValueChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setMakingWastageValue(value);
      setMakingWastagePercentage("");
      if (
        updateData.quantity &&
        updateData.weight &&
        updateData.rate &&
        value
      ) {
        const baseAmount =
          parseFloat(updateData.quantity) *
          parseFloat(updateData.weight) *
          parseFloat(updateData.rate);
        const percentage = (parseFloat(value) / baseAmount) * 100;
        setMakingWastagePercentage(percentage.toFixed(2));
      }
    }
  };

  // ==================== handleAddItem (Add / Update item) ====================
  const handleAddItem = () => {
    // Step 1: Required fields check
    if (
      !updateData.select_category ||
      (selectedAction !== "Exchange" && !updateData.select_type) ||
      !updateData.quantity ||
      !updateData.weight ||
      !updateData.rate ||
      !updateData.amount ||
      !updateData.manager
    ) {
      toast.error(
        "Please fill all required fields, including Manager and Staff",
        3000,
        "topRight"
      );
      return;
    }
    const _roleForStaffCheck =
      JSON.parse(localStorage.getItem("user") || "{}").role || "";
    const _isAdminForStaff =
      _roleForStaffCheck === "Admin" || _roleForStaffCheck === "admin";
    if (!_isAdminForStaff && !updateData.staff) {
      toast.error("Please select Staff", 3000, "topRight");
      return;
    }

    // Step 2: STOCK AVAILABILITY CHECK (by WEIGHT, not piece quantity)
    // Skipped for Exchange and Old Sales (stock tracking doesn't apply there)
    if (selectedAction !== "Exchange" && selectedAction !== "Old Sales") {
      const selectedProductForStock = products.find(
        (p) => String(p.id) === String(updateData.select_type)
      );
      const itemNameForStock =
        selectedProductForStock?.item_name_english ||
        selectedProductForStock?.item_name ||
        "";
      const category = updateData.select_category;
      const weight = parseFloat(updateData.weight) || 0;

      const stockCheck = checkStockAvailability(
        category,
        itemNameForStock,
        weight,
        updateData.select_type
      );

      if (!stockCheck.available) {
        toast.error(
          `❌ Stock Limit Exceeded! ${stockCheck.message}`,
          5000,
          "topRight"
        );
        return; // ⛔ Stop here - item will NOT be added
      }

      if (stockCheck.availableWeight > 0 && weight > stockCheck.availableWeight * 0.8) {
        toast.warning(
          `⚠️ Low stock warning! Only ${stockCheck.availableWeight.toFixed(3)}g available. You're adding ${weight.toFixed(3)}g.`,
          5000,
          "topRight"
        );
      }

      if (stockCheck.itemFound) {
        toast.success(
          `✅ Stock available: ${stockCheck.availableWeight.toFixed(3)}g`,
          2000,
          "topRight"
        );
      }
    }

    // Step 3: Purity-based price check
    // Skipped for Exchange and Old Sales (matches AddSales — those modes
    // don't price against today's pure rate the same way New/Po-Sale do).
    if (
      selectedAction !== "Exchange" &&
      selectedAction !== "Old Sales" &&
      updateData.select_type
    ) {
      const selectedProductForCheck = products.find(
        (p) => String(p.id) === String(updateData.select_type)
      );
      const purity = selectedProductForCheck?.pure_percent
        ? parseFloat(selectedProductForCheck.pure_percent) / 100
        : 1;

      const qty = parseFloat(updateData.quantity || 0);
      const weight = parseFloat(updateData.weight || 0);

      const today = formatDateToDDMMYYYY(getCurrentDate());
      const todayRateRow = dailyRatesGetting.find((r) => r.date === today) || {};

      let todaysPureRate = 0;
      if (updateData.select_category === "Gold" || updateData.select_category === "Gold Coin") {
        todaysPureRate = parseFloat(
          todayRateRow.gold_pure_percentage || rates.gold_pure_percentage || 0
        );
      } else if (
        updateData.select_category === "Silver" ||
        updateData.select_category === "Silver Coin"
      ) {
        todaysPureRate = parseFloat(
          todayRateRow.silver_pure_percentage || rates.silver_pure_percentage || 0
        );
      }

      const finalAmount = parseFloat(updateData.amount || 0); // includes making charge + wastage + stone value
      const pureRateTotal = qty * weight * purity * todaysPureRate;

      if (todaysPureRate > 0 && finalAmount < pureRateTotal) {
        const diff = (pureRateTotal - finalAmount).toFixed(2);
        toast.error(
          `⚠️ Amount ₹${finalAmount.toFixed(2)} is below Today's Pure Rate value ₹${pureRateTotal.toFixed(2)} (Diff: ₹${diff})`,
          4000,
          "topRight"
        );
        return; // ⛔ block — item not added
      }
    }

    // Step 4: Build item object (ONLY REACHED IF ALL CHECKS PASS)
    const selectedProduct = filteredProducts.find(
      (p) => p.id === parseInt(updateData.select_type),
    );
    const typeName = selectedProduct
      ? selectedProduct.item_name_english || selectedProduct.item_name
      : selectedAction === "Exchange"
        ? `Old ${updateData.select_category}`
        : "";

    const newItem = {
      sales_no: updateData.sales_no,
      category: updateData.select_category,
      item: typeName,
      type_id: updateData.select_type,
      type_name: typeName,
      type_name_tamil: selectedProduct?.item_name_tamil || "",
      quantity: updateData.quantity,
      weight: updateData.weight,
      making_charges: updateData.making_charges,
      making_wastage: makingWastageValue,
      making_wastage_percentage: makingWastagePercentage,
      rate: updateData.rate,
      amount: updateData.amount,
      action_type: selectedAction,
      manager: updateData.manager,
      staff: updateData.staff,
      stone_value: stoneValue || "0.00",
      adjustment: adjustment || "0.00",
    };

    // Step 5: Add or update item
    if (editingIndex !== null) {
      const updatedItems = [...items];
      updatedItems[editingIndex] = newItem;
      setItems(updatedItems);
      setEditingIndex(null);
    } else {
      setItems([...items, newItem]);
    }

    // Step 6: Reset form fields
    setUpdateData((prev) => ({
      ...prev,
      select_category: "",
      select_type: "",
      select_type_name: "",
      select_type_tamil: "",
      quantity: "",
      weight: "",
      rate: "",
      making_charges: "",
      amount: "0.00",
      manager: "",
      staff: "",
    }));
    setMakingWastagePercentage("");
    setMakingWastageValue("");
    setStoneValue("");
    setAdjustment("");
    setIsAdjustmentApplied(false);
    setIsRateManuallyEdited(false);
    setSelectedManager("");
    setSelectedStaff("");
    setStaffList([]);
  };
  // ==================== END handleAddItem ====================

  // ===================================================================
  // handleEditItem sets isAdjustmentApplied(false) so the amount effect
  // keeps recalculating live while you edit (matches AddSales' fix —
  // otherwise the amount would appear frozen after opening an item).
  // ===================================================================
  const handleEditItem = (index) => {
    const item = items[index];

    // Look up from the full products list, not the (possibly stale) filteredProducts
    const categoryProducts = products.filter(
      (p) => p.category === item.category
    );
    const selectedProduct =
      categoryProducts.find((p) => String(p.id) === String(item.type_id)) ||
      categoryProducts.find(
        (p) => (p.item_name_english || p.item_name) === item.type_name
      );
    const productId = selectedProduct ? selectedProduct.id : "";

    // Make sure the dropdown options are ready immediately, don't wait for the effect
    setFilteredProducts(categoryProducts);

    const managerObj = userdata.find(
  (u) => u.user_id === item.manager || u.name === item.manager
);
    const managerId = managerObj ? managerObj.id : "";

    setUpdateData((prev) => ({
      ...prev,
      select_category: item.category,
      select_type: productId,
      select_type_name: item.type_name,
      select_type_tamil: selectedProduct?.item_name_tamil || "",
      quantity: item.quantity,
      weight: item.weight,
      rate: item.rate,
      making_charges: item.making_charges,
      amount: item.amount,
      manager: item.manager,
      staff: item.staff,
    }));
    setMakingWastagePercentage(item.making_wastage_percentage || "");
    setMakingWastageValue(item.making_wastage || "");
    setStoneValue(item.stone_value || "");
    setAdjustment(item.adjustment || "");
    setSelectedAction(item.action_type);
    setSelectedManager(managerId);
    setSelectedStaff(item.staff);
    if (managerId) {
      const selectedManagerObj = userdata.find(
        (u) => u.id === parseInt(managerId),
      );
      const managerUserId = selectedManagerObj
        ? selectedManagerObj.user_id
        : "";
      setStaffList(
        Array.isArray(userdata)
          ? userdata.filter(
              (user) => user.role === "Employee" || user.role === "employee",
            )
          : [],
      );
    }

    setEditingIndex(index);
    setIsRateManuallyEdited(true);
    setIsAdjustmentApplied(false); // ✅ allow live recalculation while editing
  };

  const handleDeleteItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };

  const handleAddPayment = () => {
    if (!paymentType || !paymentAmount) {
      toast.error(
        "Please select payment type and enter amount",
        3000,
        "topRight"
      );
      return;
    }

    const newPayment = {
      sales_no: updateData.sales_no,
      date: new Date().toISOString().split("T")[0],
      payment_type: paymentType,
      amount: parseFloat(paymentAmount).toFixed(2),
    };

    const updatedPayments = [...payments, newPayment];
    setPayments(updatedPayments);

    const totalPaid = updatedPayments.reduce(
      (sum, payment) => sum + parseFloat(payment.amount || 0),
      0,
    );

    setUpdateData((prev) => ({
      ...prev,
      paid: totalPaid.toFixed(2),
      payment_history: updatedPayments,
    }));

    setPaymentType("");
    setPaymentAmount("");
  };

  const handleEditPayment = (index) => {
    const payment = payments[index];
    setPaymentType(payment.payment_type);
    setPaymentAmount(payment.amount);
    handleDeletePayment(index);
  };

  const handleDeletePayment = (index) => {
    const updatedPayments = payments.filter((_, i) => i !== index);
    setPayments(updatedPayments);

    const totalPaid = updatedPayments.reduce(
      (sum, payment) => sum + parseFloat(payment.amount || 0),
      0,
    );

    setUpdateData((prev) => ({
      ...prev,
      paid: totalPaid.toFixed(2),
      payment_history: updatedPayments,
    }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!updateData.customer_id || !items.length) {
      toast.error(
        "Please select a customer and add at least one item",
        3000,
        "topRight"
      );
      return;
    }

    try {
      const userId = localStorage.getItem("username");
      const formData = {
        id: id,
        sales_no: updateData.sales_no,
        sales_date: updateData.sales_date,
        customer_type: updateData.customer_type,
        customer_id: updateData.customer_id,
        sub_total: updateData.sub_total,
        total: updateData.total,
        discount: updateData.discount,
        discount_value: updateData.discount_value,
        round_off: updateData.round_off,
        tax: updateData.tax,
        tax_percentage: updateData.tax_percentage,
        exchange_old_value: updateData.exchange_old_value,
        net_total: updateData.net_total,
        paid: updateData.paid,
        balance: updateData.balance,
        notes: updateData.notes,
        manager: updateData.manager,
        staff: updateData.staff,
        item_list: items.map((item) => ({
          sales_no: item.sales_no,
          category: item.category,
          item: item.item,
          type_id: item.type_id,
          type_name: item.type_name,
          quantity: item.quantity,
          weight: item.weight,
          making_charges: item.making_charges,
          making_wastage: item.making_wastage,
          making_wastage_percentage: item.making_wastage_percentage,
          rate: item.rate,
          amount: item.amount,
          action_type: item.action_type,
          manager: item.manager,
          staff: item.staff,
          stone_value: item.stone_value || "0.00",
          adjustment: item.adjustment || "0.00",
        })),
        payment_history: payments,
        updated_by: userId || "",
        updated_date: new Date().toISOString(),
      };

      const response = await axios.put(
        `${ApiUrl}/Api/sales.php/${id}`,
        formData,
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      if (response.status === 200) {
        const notificationResponse = await axios.get(
          `${ApiUrl}/Api/notification.php?table_id=${id}`,
        );
        if (
          notificationResponse.data?.status &&
          notificationResponse.data.data?.length > 0
        ) {
          const notificationData = notificationResponse.data.data.find(
            (notif) =>
              notif.table_id === id.toString() && notif.viewed === "false",
          );
          if (notificationData) {
            await axios.put(
              `${ApiUrl}/Api/notification.php/${notificationData.id}`,
              {
                id: notificationData.id,
                viewed: "true",
                updated_by: userId,
                updated_date: new Date().toISOString(),
              },
              {
                headers: { "Content-Type": "application/json" },
              },
            );
          }
        }
        toast.success("Sales updated successfully!", 3000, "topRight");
        navigate("/sales");
      } else {
        toast.error(
          response.data.message || "Failed to update sales data",
          3000,
          "topRight"
        );
      }
    } catch (error) {
      console.error("Error updating data:", error);
      toast.error(
        error.response?.data?.message || "Error updating sales data",
        3000,
        "topRight"
      );
    }
  };

  const handleClear = () => {
    setUpdateData({
      sales_no: updateData.sales_no,
      sales_date: getCurrentDate(),
      customer_type: "",
      customer_id: "",
      sub_total: "0.00",
      total: "0.00",
      exchange_old_value: "0.00",
      discount: "",
      discount_value: "0.00",
      tax: "",
      tax_percentage: "0.00",
      paid: "0.00",
      balance: "0.00",
      notes: "",
      round_off: "0.00",
      net_total: "0.00",
      select_category: "",
      select_type: "",
      quantity: "",
      weight: "",
      rate: "",
      making_charges: "",
      amount: "0.00",
      manager: "",
      staff: "",
      item_list: [],
      payment_history: [],
    });
    setItems([]);
    setPayments([]);
    setSelectedAction("New");
    setCustomerDetails({ name: "", mobile: "" });
    setSearchTerm("");
    setMakingWastagePercentage("");
    setMakingWastageValue("");
    setStoneValue("");
    setAdjustment("");
    setIsAdjustmentApplied(false);
    setIsRoundOffEnabled(false);
    setIsRateManuallyEdited(false);
    setSelectedManager("");
    setSelectedStaff("");
    setStaffList([]);
  };

  const handlePrint = () => {
    navigate(`/bill/${updateData.sales_no}`);
  };

  const balanceColor =
    parseFloat(updateData.balance) < 0
      ? "red"
      : parseFloat(updateData.balance) > 0
        ? "green"
        : "black";

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4">
            <div className="card p-2 shadow-sm mb-2">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Sales ID</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Sale No"
                    disabled
                    value={updateData.sales_no}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Sales Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={updateData.sales_date}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        sales_date: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="card p-2">
              <div className="row">
                <div className="col-md-3">
                  <label className="form-label">Customer Type</label>
                  <select
                    className="form-select"
                    value={updateData.customer_type}
                    onChange={(e) => {
                      const selectedType = e.target.value;
                      setUpdateData({
                        ...updateData,
                        customer_type: selectedType,
                        customer_id: "",
                      });
                      setCustomerDetails({ name: "", mobile: "" });
                      setSearchTerm("");
                      fetchCustomer(selectedType);
                    }}
                  >
                    <option value="" disabled>
                      Customer Type
                    </option>
                    <option value="Walk-In">Walk-In</option>
                    <option value="Retailer">Retailer</option>
                    <option value="Regular">Regular</option>
                  </select>
                </div>
                <div className="col-md-3 position-relative">
                  <label className="form-label">Customer ID</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Select Customer"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setShowDropdown(true);
                    }}
                    onFocus={() => setShowDropdown(true)}
                    disabled={!updateData.customer_type}
                  />
                  {showDropdown && (
                    <div className="dropdown-menu show w-100">
                      {filteredCustomers.length > 0 ? (
                        filteredCustomers.map((item) => (
                          <button
                            key={item._id}
                            className="dropdown-item"
                            onClick={() => handleSelectCustomer(item)}
                          >
                            {item.customer_id} - {item.name}
                          </button>
                        ))
                      ) : (
                        <div className="dropdown-item text-muted">
                          {updateData.customer_type
                            ? `No ${updateData.customer_type} customers found`
                            : "Please select customer type first"}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="col-md-3">
                  <label className="form-label">Customer Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    value={customerDetails.name}
                    disabled
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Customer Mobile</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Mobile Number"
                    value={customerDetails.mobile}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card card-body">
          <div className="row mb-3">
            <div className="col-lg-4 col-md-4">
              <div className="d-flex mb-2">
                <h6 className="m-2">Item</h6>
                <div>
                  {["New", "Exchange", "Po-Sale", "Old Sales"].map((action) => (
                    <button
                      key={action}
                      className={`btn btn-sm me-2 ${
                        selectedAction === action
                          ? action === "New"
                            ? "active-new"
                            : action === "Exchange"
                              ? "active-exchange"
                              : action === "Po-Sale"
                                ? "active-posale"
                                : "active-oldsales"
                          : action === "New"
                            ? "inactive-new btn-secondary"
                            : action === "Exchange"
                              ? "inactive-exchange btn-secondary"
                              : action === "Po-Sale"
                                ? "inactive-posale bg-white text-dark border"
                                : "inactive-oldsales bg-white text-dark border"
                      }`}
                      onClick={() => setSelectedAction(action)}
                    >
                      {action}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4"></div>
            {(() => {
              const role = JSON.parse(localStorage.getItem("user") || "{}").role || "";
              const isAdmin = role === "Admin" || role === "admin";
              return (
                <>
                  <div className="col-md-2 col-lg-2">
                    <label className="form-label">
                      Manager <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      value={selectedManager}
                      onChange={handleManagerChange}
                    >
                      <option value="">Select Manager</option>
                      {userdata
                        .filter((user) => user.role === "Manager" || user.role === "manager")
                        .map((manager) => (
                          <option key={manager.id} value={manager.id}>
                            {manager.name}
                          </option>
                        ))}
                    </select>
                  </div>
                  {!isAdmin && (
                    <div className="col-md-2 col-lg-2">
                      <label className="form-label">Staff</label>
                      <select
                        className="form-select"
                        value={selectedStaff}
                        onChange={handleStaffChange}
                      >
                        <option value="">Select Staff</option>
                        {staffList.map((staff) => (
                          <option key={staff.id} value={staff.name}>
                            {staff.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </>
              );
            })()}
          </div>

          <div className="row">
            <div className="col-md-2">
              <label className="form-label">Category</label>
              <select
                className="form-select"
                value={updateData.select_category}
                onChange={handleCategoryChange}
              >
                <option value="">Select Category</option>
                <option value="Gold">Gold</option>
                <option value="Silver">Silver</option>
                <option value="Gold Coin">Gold Coin</option>
                <option value="Silver Coin">Silver Coin</option>
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label">Item Name</label>
              <select
                className="form-select"
                value={updateData.select_type}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selected = filteredProducts.find(
                    (p) => p.id === parseInt(selectedId),
                  );
                  setUpdateData({
                    ...updateData,
                    select_type: selectedId,
                    select_type_name:
                      selected?.item_name_english || selected?.item_name || "",
                    select_type_tamil: selected?.item_name_tamil || "",
                  });

                  // Stock info toast — only relevant for New / Po-Sale, the
                  // only modes where the stock check in handleAddItem runs.
                  if (
                    selectedId &&
                    selectedAction !== "Exchange" &&
                    selectedAction !== "Old Sales" &&
                    selected
                  ) {
                    const stockInfo = getStockStatus(
                      updateData.select_category,
                      selected.item_name_english || selected.item_name,
                      selectedId
                    );
                    if (stockInfo.status === "out-of-stock") {
                      toast.warning("⚠️ This item is currently out of stock!", 3000, "topRight");
                    } else if (stockInfo.status === "low-stock") {
                      toast.warning(`⚠️ Only ${stockInfo.available.toFixed(3)}g left in stock!`, 3000, "topRight");
                    } else if (stockInfo.itemFound) {
                      toast.success(`✅ ${stockInfo.available.toFixed(3)}g available in stock`, 2000, "topRight");
                    }
                  }
                }}
                disabled={!updateData.select_category}
              >
                <option value="" disabled>
                  Select Item Name
                </option>
                {filteredProducts.map((product) => {
                  const stockInfo = getStockStatus(
                    updateData.select_category,
                    product.item_name_english || product.item_name,
                    product.id
                  );
                  const stockLabel =
                    stockInfo.available !== undefined && stockInfo.itemFound
                      ? ` (Stock: ${stockInfo.available.toFixed(3)}g)`
                      : "";
                  const stockEmoji =
                    stockInfo.status === "out-of-stock"
                      ? " ❌"
                      : stockInfo.status === "low-stock"
                      ? " ⚠️"
                      : "";
                  return (
                    <option key={product.id} value={product.id}>
                      {product.item_name_tamil
                        ? `${product.item_name_english || product.item_name} / ${product.item_name_tamil}`
                        : product.item_name_english || product.item_name}
                      {stockLabel}
                      {stockEmoji}
                    </option>
                  );
                })}
              </select>
              {!updateData.select_category && filteredProducts.length === 0 && (
                <small className="text-muted text-danger">
                  Please select category first
                </small>
              )}
            </div>
            <div className="col-md-2">
              <label className="form-label">Quantity</label>
              <input
                type="text"
                inputMode="numeric"
                className="form-control"
                placeholder="Quantity"
                value={updateData.quantity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setUpdateData({ ...updateData, quantity: value });
                  }
                }}
              />
            </div>
            <div className="col-md-2">
              <label className="form-label">Weight</label>
              <input
                type="text"
                inputMode="decimal"
                className="form-control"
                placeholder="Weight (g)"
                value={updateData.weight}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d{0,3}$/.test(value)) {
                    setUpdateData({ ...updateData, weight: value });
                  }
                }}
              />
            </div>
            <div className="col-md-2">
              <label className="form-label">Rate (Pure %) ₹</label>
              <input
                type="text"
                inputMode="decimal"
                className="form-control"
                placeholder="Rate"
                value={updateData.rate}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    setUpdateData({ ...updateData, rate: value });
                    setIsRateManuallyEdited(true);
                  }
                }}
              />
            </div>
          </div>

          <div className="row">
            {(selectedAction === "New" || selectedAction === "Po-Sale") && (
              <>
                <div className="col-md-2">
                  <label className="form-label fw-bold">Stone value ₹</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    placeholder="0.00"
                    value={stoneValue}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*\.?\d*$/.test(val) || val === "") {
                        setStoneValue(val);
                      }
                    }}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Making Charge ₹</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    placeholder="Making Charges"
                    value={updateData.making_charges}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setUpdateData({
                          ...updateData,
                          making_charges: value,
                        });
                      }
                    }}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Wastage (%)</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    placeholder="Wastage %"
                    value={makingWastagePercentage}
                    onChange={handleMakingWastagePercentageChange}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Wastage Value ₹</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    placeholder="Wastage Value"
                    value={makingWastageValue}
                    onChange={handleMakingWastageValueChange}
                  />
                </div>
              </>
            )}
            {selectedAction === "Exchange" && renderAdjustmentInput()}
            <div className="col-md-2">
              <label className="form-label">Amount ₹</label>
              <input
                type="tel"
                className="form-control"
                placeholder="Amount"
                value={updateData.amount}
                readOnly
              />
            </div>
            <div className="col-md-1">
              <button
                className={`btn btn-sm mt-4 ${
                  editingIndex === null ? "btn-success" : "btn-info"
                }`}
                onClick={handleAddItem}
              >
                <i
                  className={`bi ${
                    editingIndex === null ? "bi-plus" : "bi-check"
                  }`}
                ></i>
              </button>
            </div>
          </div>
        </div>

        <div className="container-fluid mt-2">
          <div className="row">
            <div className="col-lg-8">
              <div className="card card-body">
                <h6>Item List</h6>
                <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
                  <table className="table table-layout-fixed w-100">
                    <thead className="bg-light">
                      <tr>
                        <th>S.No</th>
                        <th>Category</th>
                        <th>ItemName</th>
                        <th>Qty</th>
                        <th>Wgt (g)</th>
                        <th>Stone Value ₹</th>
                        <th>MC ₹</th>
                        <th>Rate ₹</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.length > 0 ? (
                        items.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.category}</td>
                            <td>
                              {item.type_name_tamil
                                ? `${item.type_name} / ${item.type_name_tamil}`
                                : item.type_name}
                            </td>
                            <td>{item.quantity}</td>
                            <td>
                              {item.weight} (g)
                              {item.adjustment &&
                              parseFloat(item.adjustment) !== 0 ? (
                                <small className="text-muted d-block">
                                  Adj: {parseFloat(item.adjustment) > 0 ? "+" : ""}
                                  {parseFloat(item.adjustment).toFixed(3)} g
                                </small>
                              ) : null}
                            </td>
                            <td>{item.stone_value || "-"}</td>
                            <td>{item.making_charges || "-"}</td>
                            <td>{item.rate}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-primary me-1"
                                onClick={() => handleEditItem(index)}
                              >
                                <i className="bi bi-pencil"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleDeleteItem(index)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No items added
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="row">
                    <div className="col-lg-8"></div>
                    <div className="col-lg-4">
                      <div className="d-flex">
                        <h6 className="mt-2">Total: </h6>
                        <input
                          className="form-control mx-2"
                          value={updateData.total}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Customer Sales History — same customer, same bill date only */}
              {updateData.customer_id && (
                <div className="card card-body mt-2">
                  <h6>
                    Sales History - {customerDetails.name} ({updateData.customer_id}) on {updateData.sales_date}
                  </h6>
                  <div className="p-2" style={{ backgroundColor: "#E8F0FA" }}>
                    <div className="table-container">
                      <table className="table table-layout-fixed w-100">
                        <thead className="bg-light">
                          <tr>
                            <th>Date</th>
                            <th>Sales No</th>
                            <th>Total ₹</th>
                            <th>Paid ₹</th>
                            <th>Balance ₹</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingSalesHistory ? (
                            <tr>
                              <td colSpan="5" className="text-center">
                                Loading...
                              </td>
                            </tr>
                          ) : customerSalesHistory.length > 0 ? (
                            customerSalesHistory.map((record) => (
                              <tr key={record.id || record.sales_no}>
                                <td>{record.sales_date}</td>
                                <td>{record.sales_no}</td>
                                <td>₹{parseFloat(record.net_total || 0).toFixed(2)}</td>
                                <td>₹{parseFloat(record.paid || 0).toFixed(2)}</td>
                                <td>₹{parseFloat(record.balance || 0).toFixed(2)}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No other sales for this customer on this date
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-lg-4 mb-5">
              <div className="card p-3">
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">Discount (%)</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="tel"
                      className="form-control"
                      value={updateData.discount}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          discount: e.target.value.replace(/\D/g, ""),
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="tel"
                      className="form-control"
                      value={updateData.discount_value}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Sub Total</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={updateData.sub_total}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">GST (%)</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="tel"
                      className="form-control"
                      value={updateData.tax}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          tax: e.target.value.replace(/\D/g, ""),
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="tel"
                      className="form-control"
                      value={updateData.tax_percentage}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">Round Off</label>
                  </div>
                  <div className="col-md-2">
                    <input
                      type="checkbox"
                      checked={isRoundOffEnabled}
                      onChange={(e) => setIsRoundOffEnabled(e.target.checked)}
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={updateData.round_off}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Net Total</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={updateData.net_total}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Exchange Old</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={updateData.exchange_old_value}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mb-2 d-flex justify-content-center">
                  <button
                    className="btn btn-success btn-sm w-50"
                    onClick={() => setInfoModal(true)}
                  >
                    Add Payment +
                  </button>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Paid</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={updateData.paid}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Balance</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={Math.abs(parseFloat(updateData.balance)).toFixed(
                        2,
                      )}
                      readOnly
                      style={{ color: balanceColor }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Notes</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={updateData.notes}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, notes: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between mb-3">
                 <button className="btn btn-secondary btn-sm" onClick={goBackToOrigin}>
  <i className="fa-solid fa-arrow-left"></i> Back
</button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={handleClear}
                  >
                    <i className="bi bi-x-circle"></i> Clear
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => setShowModal(true)}
                  >
                    <i className="bi bi-printer"></i> Estimate
                  </button>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={handleUpdate}
                  >
                    <i className="bi bi-save"></i> Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade ${infoModal ? "show" : ""}`}
          style={{ display: infoModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="addPaymentModalLabel"
          aria-hidden={!infoModal}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6
                  className="modal-title text-primary"
                  id="addPaymentModalLabel"
                >
                  Add Payment
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={() => setInfoModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-6">
                    <p>
                      Balance:{" "}
                      <span className="mx-3 text-success">
                        {Math.abs(parseFloat(updateData.balance)).toFixed(2)}
                      </span>
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      Paid:{" "}
                      <span className="mx-3 text-primary">
                        {updateData.paid}
                      </span>
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <select
                      className="form-select"
                      value={paymentType}
                      onChange={(e) => setPaymentType(e.target.value)}
                    >
                      <option value="">Select Paytype</option>
                      <option value="Cash">Cash</option>
                      <option value="Gpay">Gpay</option>
                      <option value="Phonepe">Phonepe</option>
                      <option value="Paytm">Paytm</option>
                      <option value="Credit">Credit</option>
                      <option value="Debit">Debit</option>
                    </select>
                  </div>
                  <div className="col-lg-4">
                    <input
                      type="tel"
                      className="form-control"
                      value={paymentAmount}
                      onChange={(e) => setPaymentAmount(e.target.value)}
                      placeholder="Enter Amount"
                    />
                  </div>
                  <div className="col-lg-2">
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={handleAddPayment}
                    >
                      Add +
                    </button>
                  </div>
                </div>
                <div
                  className="card mt-3"
                  style={{ borderRadius: "5px", backgroundColor: "#E8F0FA" }}
                >
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-border">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Pay Type</th>
                            <th>Paid Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {payments.length > 0 ? (
                            payments.map((payment, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{payment.payment_type}</td>
                                <td>{payment.amount}</td>
                                <td>
                                  <button
                                    className="btn btn-light btn-sm me-2"
                                    onClick={() => handleEditPayment(index)}
                                  >
                                    <i className="bi bi-pencil text-info"></i>
                                  </button>
                                  <button
                                    className="btn btn-light btn-sm me-2"
                                    onClick={() => handleDeletePayment(index)}
                                  >
                                    <i className="bi bi-trash text-danger"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No payments added
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="text-end mt-2">
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => setInfoModal(false)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          style={{ display: showModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="printModalLabel"
          aria-hidden={!showModal}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title text-primary" id="printModalLabel">
                  Print (If You Want Print or Not?)
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={() => setShowModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="text-center">
                    <p className="text-center">
                      If you want Print the sales Bill ?
                    </p>
                  </div>
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm mx-2"
                      onClick={() => navigate("/sales")}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={handlePrint}
                    >
                      Print
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {(showModal || infoModal) && (
          <div className="modal-backdrop fade show"></div>
        )}
      </div>
    </>
  );
}

export default UpdateSales;